import { useCurrentLocale } from './chunk-BLV7UT3X.mjs';
import { $5b160d28a433310d$export$c17fa47878dc55b6, $fca6afa0e843324b$export$f12b703ca79dfbb1, $18f2051aff69b9bf$export$43bb16f9c6d9e3f7, $896ba0a80a8f4d36$export$85fd5fdf27bacc79, $6c7bd7858deea686$export$cd11ab140839f11d, $bb77f239b46e8c72$export$3274cf84b703fff, $319e236875307eab$export$a9b970dcc4ae71a9 } from './chunk-NFYMOQMY.mjs';
import { $9bf71ea28793e738$export$c5251b9e124bf29, $9bf71ea28793e738$export$2d6ec8fc375ceafa } from './chunk-DKDY3UOQ.mjs';
import { $bdb11010cef70236$export$f680877a34711e37, $ef06256079686ba0$export$f8aeda7b10753fa1, $65484d02dcb7eb3e$export$457c3d6518dd4c6f, $3ef42575df84b30b$export$9d1611c77c2fe928, $458b0a5536c1a7cf$export$40bfa8c7b0832715, $bdb11010cef70236$export$b4cc09c592e8fdb8, $f6c31cce2adf654f$export$45712eceda6fad21, $9ab94262bd0047c7$export$420e68273165f4ec, $e9faafb641e167db$export$90fc3a17d93f704c, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c, $c87311424ea30a05$export$fedb369cb70207f1, $313b98861ee5dd6c$export$d6875122194c7b44, $03deb23ff14920c4$export$4eaf04e54aa8eed6, $c87311424ea30a05$export$9ac100e40613ea10, $2f04cbc44ee30ce0$export$53a0910f038337bd, $62d8ded9296f3872$export$cfa2225e87938781 } from './chunk-BE4IJI5E.mjs';
import { useMultiStyleConfig, Box, FormLabel, Flex } from '@chakra-ui/react';
import { DateFormatter, toCalendar, CalendarDate, Time, toCalendarDate, toCalendarDateTime, getMinimumDayInMonth, getMinimumMonthInYear, GregorianCalendar, now } from '@internationalized/date';
import React, { forwardRef, useMemo, useState, useRef, useEffect, useCallback } from 'react';

// ../../node_modules/@react-aria/label/dist/module.js
function $d191a55c9702f145$export$8467354a121f1b9f(props) {
  let { id, label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType = "label" } = props;
  id = $bdb11010cef70236$export$f680877a34711e37(id);
  let labelId = $bdb11010cef70236$export$f680877a34711e37();
  let labelProps = {};
  if (label) {
    ariaLabelledby = ariaLabelledby ? `${ariaLabelledby} ${labelId}` : labelId;
    labelProps = {
      id: labelId,
      htmlFor: labelElementType === "label" ? id : void 0
    };
  } else if (!ariaLabelledby && !ariaLabel)
    console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let fieldProps = $313b98861ee5dd6c$export$d6875122194c7b44({
    id,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby
  });
  return {
    labelProps,
    fieldProps
  };
}
function $2baaea4c71418dea$export$294aa081a6c6f55d(props) {
  let { description, errorMessage, validationState } = props;
  let { labelProps, fieldProps } = $d191a55c9702f145$export$8467354a121f1b9f(props);
  let descriptionId = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    Boolean(description),
    Boolean(errorMessage),
    validationState
  ]);
  let errorMessageId = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    Boolean(description),
    Boolean(errorMessage),
    validationState
  ]);
  fieldProps = $3ef42575df84b30b$export$9d1611c77c2fe928(fieldProps, {
    "aria-describedby": [
      descriptionId,
      errorMessageId,
      props["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  });
  return {
    labelProps,
    fieldProps,
    descriptionProps: {
      id: descriptionId
    },
    errorMessageProps: {
      id: errorMessageId
    }
  };
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $c6208a7792e31a37$exports = {};
var $ed6aae4e5f766f1e$exports = {};
$ed6aae4e5f766f1e$exports = {
  "Empty": `\u0641\u0627\u0631\u063A`
};
var $38854e2b175151fa$exports = {};
$38854e2b175151fa$exports = {
  "Empty": `\u0418\u0437\u043F\u0440\u0430\u0437\u043D\u0438`
};
var $15b25ab20f3945b2$exports = {};
$15b25ab20f3945b2$exports = {
  "Empty": `Pr\xE1zdn\xE9`
};
var $692a4298b6b649a2$exports = {};
$692a4298b6b649a2$exports = {
  "Empty": `Tom`
};
var $1c6e1539193f1243$exports = {};
$1c6e1539193f1243$exports = {
  "Empty": `Leer`
};
var $1e8678632c464b6d$exports = {};
$1e8678632c464b6d$exports = {
  "Empty": `\u0386\u03B4\u03B5\u03B9\u03BF`
};
var $4adc85d9bf5b9eed$exports = {};
$4adc85d9bf5b9eed$exports = {
  "Empty": `Empty`
};
var $41c4b2bb61dafbca$exports = {};
$41c4b2bb61dafbca$exports = {
  "Empty": `Vac\xEDo`
};
var $405f8b24f5dd2a60$exports = {};
$405f8b24f5dd2a60$exports = {
  "Empty": `T\xFChjenda`
};
var $7efe3ed02b9b9dd4$exports = {};
$7efe3ed02b9b9dd4$exports = {
  "Empty": `Tyhj\xE4`
};
var $99fc4c101d92daf3$exports = {};
$99fc4c101d92daf3$exports = {
  "Empty": `Vide`
};
var $f9e155e6e8cacaa2$exports = {};
$f9e155e6e8cacaa2$exports = {
  "Empty": `\u05E8\u05D9\u05E7`
};
var $c31b5e8e9a249fd5$exports = {};
$c31b5e8e9a249fd5$exports = {
  "Empty": `Prazno`
};
var $9c5435bc17499bd9$exports = {};
$9c5435bc17499bd9$exports = {
  "Empty": `\xDCres`
};
var $6d1fc8e84d8165e1$exports = {};
$6d1fc8e84d8165e1$exports = {
  "Empty": `Vuoto`
};
var $46ea6b3641b83e71$exports = {};
$46ea6b3641b83e71$exports = {
  "Empty": `\u7A7A`
};
var $0e3cc9a288289dc5$exports = {};
$0e3cc9a288289dc5$exports = {
  "Empty": `\uBE44\uC5B4 \uC788\uC74C`
};
var $4ff2bb25c0089ffb$exports = {};
$4ff2bb25c0089ffb$exports = {
  "Empty": `Tu\u0161\u010Dias`
};
var $6cf33cd4c010a2fb$exports = {};
$6cf33cd4c010a2fb$exports = {
  "Empty": `Tuk\u0161s`
};
var $5a9f8486f8b8837e$exports = {};
$5a9f8486f8b8837e$exports = {
  "Empty": `Tom`
};
var $583f94d807f6ecea$exports = {};
$583f94d807f6ecea$exports = {
  "Empty": `Leeg`
};
var $cc4dcfeea2b4050d$exports = {};
$cc4dcfeea2b4050d$exports = {
  "Empty": `Pusty`
};
var $68ac2954d56e12b4$exports = {};
$68ac2954d56e12b4$exports = {
  "Empty": `Vazio`
};
var $fdb0616f309780b0$exports = {};
$fdb0616f309780b0$exports = {
  "Empty": `Vazio`
};
var $fe1eccf4ee1d6f52$exports = {};
$fe1eccf4ee1d6f52$exports = {
  "Empty": `Gol`
};
var $a38b6c4e18725976$exports = {};
$a38b6c4e18725976$exports = {
  "Empty": `\u041D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E`
};
var $6c14ae2b766b652c$exports = {};
$6c14ae2b766b652c$exports = {
  "Empty": `Pr\xE1zdne`
};
var $8f1c9692e16dc5eb$exports = {};
$8f1c9692e16dc5eb$exports = {
  "Empty": `Prazen`
};
var $d2aa7abea627cafa$exports = {};
$d2aa7abea627cafa$exports = {
  "Empty": `Prazno`
};
var $676b82e4b56408e6$exports = {};
$676b82e4b56408e6$exports = {
  "Empty": `Tomt`
};
var $14c9042552d7ce08$exports = {};
$14c9042552d7ce08$exports = {
  "Empty": `Bo\u015F`
};
var $393254ebcb66c9f5$exports = {};
$393254ebcb66c9f5$exports = {
  "Empty": `\u041F\u0443\u0441\u0442\u043E`
};
var $d49d621f310cf6ce$exports = {};
$d49d621f310cf6ce$exports = {
  "Empty": `\u7A7A`
};
var $94b60c866ca5dfe6$exports = {};
$94b60c866ca5dfe6$exports = {
  "Empty": `\u7A7A\u767D`
};
$c6208a7792e31a37$exports = {
  "ar-AE": $ed6aae4e5f766f1e$exports,
  "bg-BG": $38854e2b175151fa$exports,
  "cs-CZ": $15b25ab20f3945b2$exports,
  "da-DK": $692a4298b6b649a2$exports,
  "de-DE": $1c6e1539193f1243$exports,
  "el-GR": $1e8678632c464b6d$exports,
  "en-US": $4adc85d9bf5b9eed$exports,
  "es-ES": $41c4b2bb61dafbca$exports,
  "et-EE": $405f8b24f5dd2a60$exports,
  "fi-FI": $7efe3ed02b9b9dd4$exports,
  "fr-FR": $99fc4c101d92daf3$exports,
  "he-IL": $f9e155e6e8cacaa2$exports,
  "hr-HR": $c31b5e8e9a249fd5$exports,
  "hu-HU": $9c5435bc17499bd9$exports,
  "it-IT": $6d1fc8e84d8165e1$exports,
  "ja-JP": $46ea6b3641b83e71$exports,
  "ko-KR": $0e3cc9a288289dc5$exports,
  "lt-LT": $4ff2bb25c0089ffb$exports,
  "lv-LV": $6cf33cd4c010a2fb$exports,
  "nb-NO": $5a9f8486f8b8837e$exports,
  "nl-NL": $583f94d807f6ecea$exports,
  "pl-PL": $cc4dcfeea2b4050d$exports,
  "pt-BR": $68ac2954d56e12b4$exports,
  "pt-PT": $fdb0616f309780b0$exports,
  "ro-RO": $fe1eccf4ee1d6f52$exports,
  "ru-RU": $a38b6c4e18725976$exports,
  "sk-SK": $6c14ae2b766b652c$exports,
  "sl-SI": $8f1c9692e16dc5eb$exports,
  "sr-SP": $d2aa7abea627cafa$exports,
  "sv-SE": $676b82e4b56408e6$exports,
  "tr-TR": $14c9042552d7ce08$exports,
  "uk-UA": $393254ebcb66c9f5$exports,
  "zh-CN": $d49d621f310cf6ce$exports,
  "zh-TW": $94b60c866ca5dfe6$exports
};
function $d2e8511e6f209edf$export$e908e06f4b8e3402(props) {
  const _async = useRef();
  let { value, textValue, minValue, maxValue, isDisabled, isReadOnly, isRequired, onIncrement, onIncrementPage, onDecrement, onDecrementPage, onDecrementToMin, onIncrementToMax } = props;
  const stringFormatter = $fca6afa0e843324b$export$f12b703ca79dfbb1(/* @__PURE__ */ $parcel$interopDefault($c6208a7792e31a37$exports));
  const propsRef = useRef(props);
  propsRef.current = props;
  const clearAsync = () => clearTimeout(_async.current);
  useEffect(() => {
    return () => clearAsync();
  }, []);
  let onKeyDown = (e) => {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || isReadOnly)
      return;
    switch (e.key) {
      case "PageUp":
        if (onIncrementPage) {
          e.preventDefault();
          onIncrementPage();
          break;
        }
      case "ArrowUp":
      case "Up":
        if (onIncrement) {
          e.preventDefault();
          onIncrement();
        }
        break;
      case "PageDown":
        if (onDecrementPage) {
          e.preventDefault();
          onDecrementPage();
          break;
        }
      case "ArrowDown":
      case "Down":
        if (onDecrement) {
          e.preventDefault();
          onDecrement();
        }
        break;
      case "Home":
        if (onDecrementToMin) {
          e.preventDefault();
          onDecrementToMin();
        }
        break;
      case "End":
        if (onIncrementToMax) {
          e.preventDefault();
          onIncrementToMax();
        }
        break;
    }
  };
  let isFocused = useRef(false);
  let onFocus = () => {
    isFocused.current = true;
  };
  let onBlur = () => {
    isFocused.current = false;
  };
  textValue = textValue === "" ? stringFormatter.format("Empty") : (textValue || `${value}`).replace("-", "\u2212");
  useEffect(() => {
    if (isFocused.current)
      $319e236875307eab$export$a9b970dcc4ae71a9(textValue, "assertive");
  }, [
    textValue
  ]);
  const onIncrementPressStart = useCallback((initialStepDelay) => {
    clearAsync();
    propsRef.current.onIncrement();
    _async.current = window.setTimeout(() => {
      if (isNaN(maxValue) || isNaN(value) || value < maxValue)
        onIncrementPressStart(60);
    }, initialStepDelay);
  }, [
    onIncrement,
    maxValue,
    value
  ]);
  const onDecrementPressStart = useCallback((initialStepDelay) => {
    clearAsync();
    propsRef.current.onDecrement();
    _async.current = window.setTimeout(() => {
      if (isNaN(minValue) || isNaN(value) || value > minValue)
        onDecrementPressStart(60);
    }, initialStepDelay);
  }, [
    onDecrement,
    minValue,
    value
  ]);
  let cancelContextMenu = (e) => {
    e.preventDefault();
  };
  let { addGlobalListener, removeAllGlobalListeners } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  return {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": !isNaN(value) ? value : null,
      "aria-valuetext": textValue,
      "aria-valuemin": minValue,
      "aria-valuemax": maxValue,
      "aria-disabled": isDisabled || null,
      "aria-readonly": isReadOnly || null,
      "aria-required": isRequired || null,
      onKeyDown,
      onFocus,
      onBlur
    },
    incrementButtonProps: {
      onPressStart: () => {
        onIncrementPressStart(400);
        addGlobalListener(window, "contextmenu", cancelContextMenu);
      },
      onPressEnd: () => {
        clearAsync();
        removeAllGlobalListeners();
      },
      onFocus,
      onBlur
    },
    decrementButtonProps: {
      onPressStart: () => {
        onDecrementPressStart(400);
        addGlobalListener(window, "contextmenu", cancelContextMenu);
      },
      onPressEnd: () => {
        clearAsync();
        removeAllGlobalListeners();
      },
      onFocus,
      onBlur
    }
  };
}

// ../../node_modules/@react-aria/datepicker/dist/module.js
function $parcel$interopDefault2(a) {
  return a && a.__esModule ? a.default : a;
}
var $204383cf4f6b0d06$exports = {};
var $f23889fffbde9058$exports = {};
$f23889fffbde9058$exports = {
  "calendar": `\u0627\u0644\u062A\u0642\u0648\u064A\u0645`,
  "day": `\u064A\u0648\u0645`,
  "dayPeriod": `\u0635/\u0645`,
  "endDate": `\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621`,
  "era": `\u0627\u0644\u0639\u0635\u0631`,
  "hour": `\u0627\u0644\u0633\u0627\u0639\u0627\u062A`,
  "minute": `\u0627\u0644\u062F\u0642\u0627\u0626\u0642`,
  "month": `\u0627\u0644\u0634\u0647\u0631`,
  "second": `\u0627\u0644\u062B\u0648\u0627\u0646\u064A`,
  "selectedDateDescription": (args) => `\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ${args.date}`,
  "selectedRangeDescription": (args) => `\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ${args.startDate} \u0625\u0644\u0649 ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062D\u062F\u062F: ${args.time}`,
  "startDate": `\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621`,
  "timeZoneName": `\u0627\u0644\u062A\u0648\u0642\u064A\u062A`,
  "weekday": `\u0627\u0644\u064A\u0648\u0645`,
  "year": `\u0627\u0644\u0633\u0646\u0629`
};
var $09d9badaa8903929$exports = {};
$09d9badaa8903929$exports = {
  "calendar": `\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440`,
  "day": `\u0434\u0435\u043D`,
  "dayPeriod": `\u043F\u0440.\u043E\u0431./\u0441\u043B.\u043E\u0431.`,
  "endDate": `\u041A\u0440\u0430\u0439\u043D\u0430 \u0434\u0430\u0442\u0430`,
  "era": `\u0435\u0440\u0430`,
  "hour": `\u0447\u0430\u0441`,
  "minute": `\u043C\u0438\u043D\u0443\u0442\u0430`,
  "month": `\u043C\u0435\u0441\u0435\u0446`,
  "second": `\u0441\u0435\u043A\u0443\u043D\u0434\u0430`,
  "selectedDateDescription": (args) => `\u0418\u0437\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ${args.date}`,
  "selectedRangeDescription": (args) => `\u0418\u0437\u0431\u0440\u0430\u043D \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ${args.startDate} \u0434\u043E ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u0418\u0437\u0431\u0440\u0430\u043D\u043E \u0432\u0440\u0435\u043C\u0435: ${args.time}`,
  "startDate": `\u041D\u0430\u0447\u0430\u043B\u043D\u0430 \u0434\u0430\u0442\u0430`,
  "timeZoneName": `\u0447\u0430\u0441\u043E\u0432\u0430 \u0437\u043E\u043D\u0430`,
  "weekday": `\u0434\u0435\u043D \u043E\u0442 \u0441\u0435\u0434\u043C\u0438\u0446\u0430\u0442\u0430`,
  "year": `\u0433\u043E\u0434\u0438\u043D\u0430`
};
var $151b77e0fd711730$exports = {};
$151b77e0fd711730$exports = {
  "calendar": `Kalend\xE1\u0159`,
  "day": `den`,
  "dayPeriod": `\u010D\xE1st dne`,
  "endDate": `Kone\u010Dn\xE9 datum`,
  "era": `letopo\u010Det`,
  "hour": `hodina`,
  "minute": `minuta`,
  "month": `m\u011Bs\xEDc`,
  "second": `sekunda`,
  "selectedDateDescription": (args) => `Vybran\xE9 datum: ${args.date}`,
  "selectedRangeDescription": (args) => `Vybran\xE9 obdob\xED: ${args.startDate} a\u017E ${args.endDate}`,
  "selectedTimeDescription": (args) => `Vybran\xFD \u010Das: ${args.time}`,
  "startDate": `Po\u010D\xE1te\u010Dn\xED datum`,
  "timeZoneName": `\u010Dasov\xE9 p\xE1smo`,
  "weekday": `den v t\xFDdnu`,
  "year": `rok`
};
var $61915aa8630b90a2$exports = {};
$61915aa8630b90a2$exports = {
  "calendar": `Kalender`,
  "day": `dag`,
  "dayPeriod": `AM/PM`,
  "endDate": `Slutdato`,
  "era": `\xE6ra`,
  "hour": `time`,
  "minute": `minut`,
  "month": `m\xE5ned`,
  "second": `sekund`,
  "selectedDateDescription": (args) => `Valgt dato: ${args.date}`,
  "selectedRangeDescription": (args) => `Valgt interval: ${args.startDate} til ${args.endDate}`,
  "selectedTimeDescription": (args) => `Valgt tidspunkt: ${args.time}`,
  "startDate": `Startdato`,
  "timeZoneName": `tidszone`,
  "weekday": `ugedag`,
  "year": `\xE5r`
};
var $35cea00159787840$exports = {};
$35cea00159787840$exports = {
  "calendar": `Kalender`,
  "day": `Tag`,
  "dayPeriod": `Tagesh\xE4lfte`,
  "endDate": `Enddatum`,
  "era": `Epoche`,
  "hour": `Stunde`,
  "minute": `Minute`,
  "month": `Monat`,
  "second": `Sekunde`,
  "selectedDateDescription": (args) => `Ausgew\xE4hltes Datum: ${args.date}`,
  "selectedRangeDescription": (args) => `Ausgew\xE4hlter Bereich: ${args.startDate} bis ${args.endDate}`,
  "selectedTimeDescription": (args) => `Ausgew\xE4hlte Zeit: ${args.time}`,
  "startDate": `Anfangsdatum`,
  "timeZoneName": `Zeitzone`,
  "weekday": `Wochentag`,
  "year": `Jahr`
};
var $518b4e82b9eacafd$exports = {};
$518b4e82b9eacafd$exports = {
  "calendar": `\u0397\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF`,
  "day": `\u03B7\u03BC\u03AD\u03C1\u03B1`,
  "dayPeriod": `\u03C0.\u03BC./\u03BC.\u03BC.`,
  "endDate": `\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2`,
  "era": `\u03C0\u03B5\u03C1\u03AF\u03BF\u03B4\u03BF\u03C2`,
  "hour": `\u03CE\u03C1\u03B1`,
  "minute": `\u03BB\u03B5\u03C0\u03C4\u03CC`,
  "month": `\u03BC\u03AE\u03BD\u03B1\u03C2`,
  "second": `\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF`,
  "selectedDateDescription": (args) => `\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1: ${args.date}`,
  "selectedRangeDescription": (args) => `\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03B5\u03CD\u03C1\u03BF\u03C2: ${args.startDate} \u03AD\u03C9\u03C2 ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03CE\u03C1\u03B1: ${args.time}`,
  "startDate": `\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2`,
  "timeZoneName": `\u03B6\u03CE\u03BD\u03B7 \u03CE\u03C1\u03B1\u03C2`,
  "weekday": `\u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AE`,
  "year": `\u03AD\u03C4\u03BF\u03C2`
};
var $1c2b297f7e2cf474$exports = {};
$1c2b297f7e2cf474$exports = {
  "era": `era`,
  "year": `year`,
  "month": `month`,
  "day": `day`,
  "hour": `hour`,
  "minute": `minute`,
  "second": `second`,
  "dayPeriod": `AM/PM`,
  "calendar": `Calendar`,
  "startDate": `Start Date`,
  "endDate": `End Date`,
  "weekday": `day of the week`,
  "timeZoneName": `time zone`,
  "selectedDateDescription": (args) => `Selected Date: ${args.date}`,
  "selectedRangeDescription": (args) => `Selected Range: ${args.startDate} to ${args.endDate}`,
  "selectedTimeDescription": (args) => `Selected Time: ${args.time}`
};
var $07f628a707cf9b18$exports = {};
$07f628a707cf9b18$exports = {
  "calendar": `Calendario`,
  "day": `d\xEDa`,
  "dayPeriod": `a.\xA0m./p.\xA0m.`,
  "endDate": `Fecha final`,
  "era": `era`,
  "hour": `hora`,
  "minute": `minuto`,
  "month": `mes`,
  "second": `segundo`,
  "selectedDateDescription": (args) => `Fecha seleccionada: ${args.date}`,
  "selectedRangeDescription": (args) => `Rango seleccionado: ${args.startDate} a ${args.endDate}`,
  "selectedTimeDescription": (args) => `Hora seleccionada: ${args.time}`,
  "startDate": `Fecha de inicio`,
  "timeZoneName": `zona horaria`,
  "weekday": `d\xEDa de la semana`,
  "year": `a\xF1o`
};
var $db553ffe17c7f4db$exports = {};
$db553ffe17c7f4db$exports = {
  "calendar": `Kalender`,
  "day": `p\xE4ev`,
  "dayPeriod": `enne/p\xE4rast l\xF5unat`,
  "endDate": `L\xF5ppkuup\xE4ev`,
  "era": `ajastu`,
  "hour": `tund`,
  "minute": `minut`,
  "month": `kuu`,
  "second": `sekund`,
  "selectedDateDescription": (args) => `Valitud kuup\xE4ev: ${args.date}`,
  "selectedRangeDescription": (args) => `Valitud vahemik: ${args.startDate} kuni ${args.endDate}`,
  "selectedTimeDescription": (args) => `Valitud aeg: ${args.time}`,
  "startDate": `Alguskuup\xE4ev`,
  "timeZoneName": `ajav\xF6\xF6nd`,
  "weekday": `n\xE4dalap\xE4ev`,
  "year": `aasta`
};
var $4afcfe00cd703f83$exports = {};
$4afcfe00cd703f83$exports = {
  "calendar": `Kalenteri`,
  "day": `p\xE4iv\xE4`,
  "dayPeriod": `vuorokaudenaika`,
  "endDate": `P\xE4\xE4ttymisp\xE4iv\xE4`,
  "era": `aikakausi`,
  "hour": `tunti`,
  "minute": `minuutti`,
  "month": `kuukausi`,
  "second": `sekunti`,
  "selectedDateDescription": (args) => `Valittu p\xE4iv\xE4m\xE4\xE4r\xE4: ${args.date}`,
  "selectedRangeDescription": (args) => `Valittu aikav\xE4li: ${args.startDate} \u2013 ${args.endDate}`,
  "selectedTimeDescription": (args) => `Valittu aika: ${args.time}`,
  "startDate": `Alkamisp\xE4iv\xE4`,
  "timeZoneName": `aikavy\xF6hyke`,
  "weekday": `viikonp\xE4iv\xE4`,
  "year": `vuosi`
};
var $1d2645d18d4c5be0$exports = {};
$1d2645d18d4c5be0$exports = {
  "calendar": `Calendrier`,
  "day": `jour`,
  "dayPeriod": `cadran`,
  "endDate": `Date de fin`,
  "era": `\xE8re`,
  "hour": `heure`,
  "minute": `minute`,
  "month": `mois`,
  "second": `seconde`,
  "selectedDateDescription": (args) => `Date s\xE9lectionn\xE9e\xA0: ${args.date}`,
  "selectedRangeDescription": (args) => `Plage s\xE9lectionn\xE9e\xA0: ${args.startDate} au ${args.endDate}`,
  "selectedTimeDescription": (args) => `Heure choisie\xA0: ${args.time}`,
  "startDate": `Date de d\xE9but`,
  "timeZoneName": `fuseau horaire`,
  "weekday": `jour de la semaine`,
  "year": `ann\xE9e`
};
var $64cb6a9be1f6fa48$exports = {};
$64cb6a9be1f6fa48$exports = {
  "calendar": `\u05DC\u05D5\u05D7 \u05E9\u05E0\u05D4`,
  "day": `\u05D9\u05D5\u05DD`,
  "dayPeriod": `\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6/\u05D0\u05D7\u05D4\u05F4\u05E6`,
  "endDate": `\u05EA\u05D0\u05E8\u05D9\u05DA \u05E1\u05D9\u05D5\u05DD`,
  "era": `\u05EA\u05E7\u05D5\u05E4\u05D4`,
  "hour": `\u05E9\u05E2\u05D4`,
  "minute": `\u05D3\u05E7\u05D4`,
  "month": `\u05D7\u05D5\u05D3\u05E9`,
  "second": `\u05E9\u05E0\u05D9\u05D9\u05D4`,
  "selectedDateDescription": (args) => `\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ${args.date}`,
  "selectedRangeDescription": (args) => `\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ${args.startDate} \u05E2\u05D3 ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u05D6\u05DE\u05DF \u05E0\u05D1\u05D7\u05E8: ${args.time}`,
  "startDate": `\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05EA\u05D7\u05DC\u05D4`,
  "timeZoneName": `\u05D0\u05D6\u05D5\u05E8 \u05D6\u05DE\u05DF`,
  "weekday": `\u05D9\u05D5\u05DD \u05D1\u05E9\u05D1\u05D5\u05E2`,
  "year": `\u05E9\u05E0\u05D4`
};
var $2a1ef2e8050be27a$exports = {};
$2a1ef2e8050be27a$exports = {
  "calendar": `Kalendar`,
  "day": `dan`,
  "dayPeriod": `AM/PM`,
  "endDate": `Datum zavr\u0161etka`,
  "era": `era`,
  "hour": `sat`,
  "minute": `minuta`,
  "month": `mjesec`,
  "second": `sekunda`,
  "selectedDateDescription": (args) => `Odabrani datum: ${args.date}`,
  "selectedRangeDescription": (args) => `Odabrani raspon: ${args.startDate} do ${args.endDate}`,
  "selectedTimeDescription": (args) => `Odabrano vrijeme: ${args.time}`,
  "startDate": `Datum po\u010Detka`,
  "timeZoneName": `vremenska zona`,
  "weekday": `dan u tjednu`,
  "year": `godina`
};
var $ad429dca102acd0e$exports = {};
$ad429dca102acd0e$exports = {
  "calendar": `Napt\xE1r`,
  "day": `nap`,
  "dayPeriod": `napszak`,
  "endDate": `Befejez\u0151 d\xE1tum`,
  "era": `\xE9ra`,
  "hour": `\xF3ra`,
  "minute": `perc`,
  "month": `h\xF3nap`,
  "second": `m\xE1sodperc`,
  "selectedDateDescription": (args) => `Kijel\xF6lt d\xE1tum: ${args.date}`,
  "selectedRangeDescription": (args) => `Kijel\xF6lt tartom\xE1ny: ${args.startDate}\u2013${args.endDate}`,
  "selectedTimeDescription": (args) => `Kijel\xF6lt id\u0151: ${args.time}`,
  "startDate": `Kezd\u0151 d\xE1tum`,
  "timeZoneName": `id\u0151z\xF3na`,
  "weekday": `h\xE9t napja`,
  "year": `\xE9v`
};
var $6e68cb5d1cb97bd2$exports = {};
$6e68cb5d1cb97bd2$exports = {
  "calendar": `Calendario`,
  "day": `giorno`,
  "dayPeriod": `AM/PM`,
  "endDate": `Data finale`,
  "era": `era`,
  "hour": `ora`,
  "minute": `minuto`,
  "month": `mese`,
  "second": `secondo`,
  "selectedDateDescription": (args) => `Data selezionata: ${args.date}`,
  "selectedRangeDescription": (args) => `Intervallo selezionato: da ${args.startDate} a ${args.endDate}`,
  "selectedTimeDescription": (args) => `Ora selezionata: ${args.time}`,
  "startDate": `Data iniziale`,
  "timeZoneName": `fuso orario`,
  "weekday": `giorno della settimana`,
  "year": `anno`
};
var $a82ee9af063ee069$exports = {};
$a82ee9af063ee069$exports = {
  "calendar": `\u30AB\u30EC\u30F3\u30C0\u30FC`,
  "day": `\u65E5`,
  "dayPeriod": `\u5348\u524D/\u5348\u5F8C`,
  "endDate": `\u7D42\u4E86\u65E5`,
  "era": `\u6642\u4EE3`,
  "hour": `\u6642`,
  "minute": `\u5206`,
  "month": `\u6708`,
  "second": `\u79D2`,
  "selectedDateDescription": (args) => `\u9078\u629E\u3057\u305F\u65E5\u4ED8 : ${args.date}`,
  "selectedRangeDescription": (args) => `\u9078\u629E\u7BC4\u56F2 : ${args.startDate} \u304B\u3089 ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u9078\u629E\u3057\u305F\u6642\u9593 : ${args.time}`,
  "startDate": `\u958B\u59CB\u65E5`,
  "timeZoneName": `\u30BF\u30A4\u30E0\u30BE\u30FC\u30F3`,
  "weekday": `\u66DC\u65E5`,
  "year": `\u5E74`
};
var $67e9091dbf37d4eb$exports = {};
$67e9091dbf37d4eb$exports = {
  "calendar": `\uB2EC\uB825`,
  "day": `\uC77C`,
  "dayPeriod": `\uC624\uC804/\uC624\uD6C4`,
  "endDate": `\uC885\uB8CC \uB0A0\uC9DC`,
  "era": `\uC5F0\uD638`,
  "hour": `\uC2DC`,
  "minute": `\uBD84`,
  "month": `\uC6D4`,
  "second": `\uCD08`,
  "selectedDateDescription": (args) => `\uC120\uD0DD \uC77C\uC790: ${args.date}`,
  "selectedRangeDescription": (args) => `\uC120\uD0DD \uBC94\uC704: ${args.startDate} ~ ${args.endDate}`,
  "selectedTimeDescription": (args) => `\uC120\uD0DD \uC2DC\uAC04: ${args.time}`,
  "startDate": `\uC2DC\uC791 \uB0A0\uC9DC`,
  "timeZoneName": `\uC2DC\uAC04\uB300`,
  "weekday": `\uC694\uC77C`,
  "year": `\uB144`
};
var $75834f9729f653d1$exports = {};
$75834f9729f653d1$exports = {
  "calendar": `Kalendorius`,
  "day": `diena`,
  "dayPeriod": `iki piet\u0173 / po piet\u0173`,
  "endDate": `Pabaigos data`,
  "era": `era`,
  "hour": `valanda`,
  "minute": `minut\u0117`,
  "month": `m\u0117nuo`,
  "second": `sekund\u0117`,
  "selectedDateDescription": (args) => `Pasirinkta data: ${args.date}`,
  "selectedRangeDescription": (args) => `Pasirinktas intervalas: nuo ${args.startDate} iki ${args.endDate}`,
  "selectedTimeDescription": (args) => `Pasirinktas laikas: ${args.time}`,
  "startDate": `Prad\u017Eios data`,
  "timeZoneName": `laiko juosta`,
  "weekday": `savait\u0117s diena`,
  "year": `metai`
};
var $a2df2c2520b4a7f0$exports = {};
$a2df2c2520b4a7f0$exports = {
  "calendar": `Kalend\u0101rs`,
  "day": `diena`,
  "dayPeriod": `priek\u0161pusdien\u0101/p\u0113cpusdien\u0101`,
  "endDate": `Beigu datums`,
  "era": `\u0113ra`,
  "hour": `stundas`,
  "minute": `min\u016Btes`,
  "month": `m\u0113nesis`,
  "second": `sekundes`,
  "selectedDateDescription": (args) => `Atlas\u012Btais datums: ${args.date}`,
  "selectedRangeDescription": (args) => `Atlas\u012Btais diapazons: no ${args.startDate} l\u012Bdz ${args.endDate}`,
  "selectedTimeDescription": (args) => `Atlas\u012Btais laiks: ${args.time}`,
  "startDate": `S\u0101kuma datums`,
  "timeZoneName": `laika josla`,
  "weekday": `ned\u0113\u013Cas diena`,
  "year": `gads`
};
var $aedcd71db4933ed5$exports = {};
$aedcd71db4933ed5$exports = {
  "calendar": `Kalender`,
  "day": `dag`,
  "dayPeriod": `a.m./p.m.`,
  "endDate": `Sluttdato`,
  "era": `tidsalder`,
  "hour": `time`,
  "minute": `minutt`,
  "month": `m\xE5ned`,
  "second": `sekund`,
  "selectedDateDescription": (args) => `Valgt dato: ${args.date}`,
  "selectedRangeDescription": (args) => `Valgt omr\xE5de: ${args.startDate} til ${args.endDate}`,
  "selectedTimeDescription": (args) => `Valgt tid: ${args.time}`,
  "startDate": `Startdato`,
  "timeZoneName": `tidssone`,
  "weekday": `ukedag`,
  "year": `\xE5r`
};
var $3b2df9e54353046c$exports = {};
$3b2df9e54353046c$exports = {
  "calendar": `Kalender`,
  "day": `dag`,
  "dayPeriod": `a.m./p.m.`,
  "endDate": `Einddatum`,
  "era": `tijdperk`,
  "hour": `uur`,
  "minute": `minuut`,
  "month": `maand`,
  "second": `seconde`,
  "selectedDateDescription": (args) => `Geselecteerde datum: ${args.date}`,
  "selectedRangeDescription": (args) => `Geselecteerd bereik: ${args.startDate} tot ${args.endDate}`,
  "selectedTimeDescription": (args) => `Geselecteerde tijd: ${args.time}`,
  "startDate": `Startdatum`,
  "timeZoneName": `tijdzone`,
  "weekday": `dag van de week`,
  "year": `jaar`
};
var $c03fe977fcfafe93$exports = {};
$c03fe977fcfafe93$exports = {
  "calendar": `Kalendarz`,
  "day": `dzie\u0144`,
  "dayPeriod": `rano / po po\u0142udniu / wieczorem`,
  "endDate": `Data ko\u0144cowa`,
  "era": `era`,
  "hour": `godzina`,
  "minute": `minuta`,
  "month": `miesi\u0105c`,
  "second": `sekunda`,
  "selectedDateDescription": (args) => `Wybrana data: ${args.date}`,
  "selectedRangeDescription": (args) => `Wybrany zakres: ${args.startDate} do ${args.endDate}`,
  "selectedTimeDescription": (args) => `Wybrany czas: ${args.time}`,
  "startDate": `Data pocz\u0105tkowa`,
  "timeZoneName": `strefa czasowa`,
  "weekday": `dzie\u0144 tygodnia`,
  "year": `rok`
};
var $569f006fc292345f$exports = {};
$569f006fc292345f$exports = {
  "calendar": `Calend\xE1rio`,
  "day": `dia`,
  "dayPeriod": `AM/PM`,
  "endDate": `Data final`,
  "era": `era`,
  "hour": `hora`,
  "minute": `minuto`,
  "month": `m\xEAs`,
  "second": `segundo`,
  "selectedDateDescription": (args) => `Data selecionada: ${args.date}`,
  "selectedRangeDescription": (args) => `Intervalo selecionado: ${args.startDate} a ${args.endDate}`,
  "selectedTimeDescription": (args) => `Hora selecionada: ${args.time}`,
  "startDate": `Data inicial`,
  "timeZoneName": `fuso hor\xE1rio`,
  "weekday": `dia da semana`,
  "year": `ano`
};
var $7c2494e14452f2dd$exports = {};
$7c2494e14452f2dd$exports = {
  "calendar": `Calend\xE1rio`,
  "day": `dia`,
  "dayPeriod": `am/pm`,
  "endDate": `Data de T\xE9rmino`,
  "era": `era`,
  "hour": `hora`,
  "minute": `minuto`,
  "month": `m\xEAs`,
  "second": `segundo`,
  "selectedDateDescription": (args) => `Data selecionada: ${args.date}`,
  "selectedRangeDescription": (args) => `Intervalo selecionado: ${args.startDate} a ${args.endDate}`,
  "selectedTimeDescription": (args) => `Hora selecionada: ${args.time}`,
  "startDate": `Data de In\xEDcio`,
  "timeZoneName": `fuso hor\xE1rio`,
  "weekday": `dia da semana`,
  "year": `ano`
};
var $eb82ef981b5592bf$exports = {};
$eb82ef981b5592bf$exports = {
  "calendar": `Calendar`,
  "day": `zi`,
  "dayPeriod": `a.m/p.m.`,
  "endDate": `Dat\u0103 final`,
  "era": `er\u0103`,
  "hour": `or\u0103`,
  "minute": `minut`,
  "month": `lun\u0103`,
  "second": `secund\u0103`,
  "selectedDateDescription": (args) => `Dat\u0103 selectat\u0103: ${args.date}`,
  "selectedRangeDescription": (args) => `Interval selectat: de la ${args.startDate} p\xE2n\u0103 la ${args.endDate}`,
  "selectedTimeDescription": (args) => `Ora selectat\u0103: ${args.time}`,
  "startDate": `Dat\u0103 \xEEnceput`,
  "timeZoneName": `fus orar`,
  "weekday": `ziua din s\u0103pt\u0103m\xE2n\u0103`,
  "year": `an`
};
var $6efa0e119f396950$exports = {};
$6efa0e119f396950$exports = {
  "calendar": `\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C`,
  "day": `\u0434\u0435\u043D\u044C`,
  "dayPeriod": `AM/PM`,
  "endDate": `\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F`,
  "era": `\u044D\u0440\u0430`,
  "hour": `\u0447\u0430\u0441`,
  "minute": `\u043C\u0438\u043D\u0443\u0442\u0430`,
  "month": `\u043C\u0435\u0441\u044F\u0446`,
  "second": `\u0441\u0435\u043A\u0443\u043D\u0434\u0430`,
  "selectedDateDescription": (args) => `\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430: ${args.date}`,
  "selectedRangeDescription": (args) => `\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: \u0441 ${args.startDate} \u043F\u043E ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F: ${args.time}`,
  "startDate": `\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430`,
  "timeZoneName": `\u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u044F\u0441`,
  "weekday": `\u0434\u0435\u043D\u044C \u043D\u0435\u0434\u0435\u043B\u0438`,
  "year": `\u0433\u043E\u0434`
};
var $7f5e57085d7f5049$exports = {};
$7f5e57085d7f5049$exports = {
  "calendar": `Kalend\xE1r`,
  "day": `de\u0148`,
  "dayPeriod": `AM/PM`,
  "endDate": `D\xE1tum ukon\u010Denia`,
  "era": `letopo\u010Det`,
  "hour": `hodina`,
  "minute": `min\xFAta`,
  "month": `mesiac`,
  "second": `sekunda`,
  "selectedDateDescription": (args) => `Vybrat\xFD d\xE1tum: ${args.date}`,
  "selectedRangeDescription": (args) => `Vybrat\xFD rozsah: od ${args.startDate} do ${args.endDate}`,
  "selectedTimeDescription": (args) => `Vybrat\xFD \u010Das: ${args.time}`,
  "startDate": `D\xE1tum za\u010Datia`,
  "timeZoneName": `\u010Dasov\xE9 p\xE1smo`,
  "weekday": `de\u0148 t\xFD\u017Ed\u0148a`,
  "year": `rok`
};
var $578ee7c11dcdde7a$exports = {};
$578ee7c11dcdde7a$exports = {
  "calendar": `Koledar`,
  "day": `dan`,
  "dayPeriod": `dop/pop`,
  "endDate": `Datum konca`,
  "era": `doba`,
  "hour": `ura`,
  "minute": `minuta`,
  "month": `mesec`,
  "second": `sekunda`,
  "selectedDateDescription": (args) => `Izbrani datum: ${args.date}`,
  "selectedRangeDescription": (args) => `Izbrano obmo\u010Dje: ${args.startDate} do ${args.endDate}`,
  "selectedTimeDescription": (args) => `Izbrani \u010Das: ${args.time}`,
  "startDate": `Datum za\u010Detka`,
  "timeZoneName": `\u010Dasovni pas`,
  "weekday": `dan v tednu`,
  "year": `leto`
};
var $bbc3fd6cd0bc9d50$exports = {};
$bbc3fd6cd0bc9d50$exports = {
  "calendar": `Kalendar`,
  "day": `\u0434\u0430\u043D`,
  "dayPeriod": `\u043F\u0440\u0435 \u043F\u043E\u0434\u043D\u0435/\u043F\u043E \u043F\u043E\u0434\u043D\u0435`,
  "endDate": `Datum zavr\u0161etka`,
  "era": `\u0435\u0440\u0430`,
  "hour": `\u0441\u0430\u0442`,
  "minute": `\u043C\u0438\u043D\u0443\u0442`,
  "month": `\u043C\u0435\u0441\u0435\u0446`,
  "second": `\u0441\u0435\u043A\u0443\u043D\u0434`,
  "selectedDateDescription": (args) => `Izabrani datum: ${args.date}`,
  "selectedRangeDescription": (args) => `Izabrani opseg: od ${args.startDate} do ${args.endDate}`,
  "selectedTimeDescription": (args) => `Izabrano vreme: ${args.time}`,
  "startDate": `Datum po\u010Detka`,
  "timeZoneName": `\u0432\u0440\u0435\u043C\u0435\u043D\u0441\u043A\u0430 \u0437\u043E\u043D\u0430`,
  "weekday": `\u0434\u0430\u043D \u0443 \u043D\u0435\u0434\u0435\u0459\u0438`,
  "year": `\u0433\u043E\u0434\u0438\u043D\u0430`
};
var $0b04512118591d2a$exports = {};
$0b04512118591d2a$exports = {
  "calendar": `Kalender`,
  "day": `dag`,
  "dayPeriod": `fm/em`,
  "endDate": `Slutdatum`,
  "era": `era`,
  "hour": `timme`,
  "minute": `minut`,
  "month": `m\xE5nad`,
  "second": `sekund`,
  "selectedDateDescription": (args) => `Valt datum: ${args.date}`,
  "selectedRangeDescription": (args) => `Valt intervall: ${args.startDate} till ${args.endDate}`,
  "selectedTimeDescription": (args) => `Vald tid: ${args.time}`,
  "startDate": `Startdatum`,
  "timeZoneName": `tidszon`,
  "weekday": `veckodag`,
  "year": `\xE5r`
};
var $3a49d121fe4c9e1d$exports = {};
$3a49d121fe4c9e1d$exports = {
  "calendar": `Takvim`,
  "day": `g\xFCn`,
  "dayPeriod": `\xD6\xD6/\xD6S`,
  "endDate": `Biti\u015F Tarihi`,
  "era": `\xE7a\u011F`,
  "hour": `saat`,
  "minute": `dakika`,
  "month": `ay`,
  "second": `saniye`,
  "selectedDateDescription": (args) => `Se\xE7ilen Tarih: ${args.date}`,
  "selectedRangeDescription": (args) => `Se\xE7ilen Aral\u0131k: ${args.startDate} - ${args.endDate}`,
  "selectedTimeDescription": (args) => `Se\xE7ilen Zaman: ${args.time}`,
  "startDate": `Ba\u015Flang\u0131\xE7 Tarihi`,
  "timeZoneName": `saat dilimi`,
  "weekday": `haftan\u0131n g\xFCn\xFC`,
  "year": `y\u0131l`
};
var $5ba21dbb8914919d$exports = {};
$5ba21dbb8914919d$exports = {
  "calendar": `\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440`,
  "day": `\u0434\u0435\u043D\u044C`,
  "dayPeriod": `\u0434\u043F/\u043F\u043F`,
  "endDate": `\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F`,
  "era": `\u0435\u0440\u0430`,
  "hour": `\u0433\u043E\u0434\u0438\u043D\u0430`,
  "minute": `\u0445\u0432\u0438\u043B\u0438\u043D\u0430`,
  "month": `\u043C\u0456\u0441\u044F\u0446\u044C`,
  "second": `\u0441\u0435\u043A\u0443\u043D\u0434\u0430`,
  "selectedDateDescription": (args) => `\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ${args.date}`,
  "selectedRangeDescription": (args) => `\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ${args.startDate} \u2014 ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0447\u0430\u0441: ${args.time}`,
  "startDate": `\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443`,
  "timeZoneName": `\u0447\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441`,
  "weekday": `\u0434\u0435\u043D\u044C \u0442\u0438\u0436\u043D\u044F`,
  "year": `\u0440\u0456\u043A`
};
var $51078838e1b16cd7$exports = {};
$51078838e1b16cd7$exports = {
  "calendar": `\u65E5\u5386`,
  "day": `\u65E5`,
  "dayPeriod": `\u4E0A\u5348/\u4E0B\u5348`,
  "endDate": `\u7ED3\u675F\u65E5\u671F`,
  "era": `\u7EAA\u5143`,
  "hour": `\u5C0F\u65F6`,
  "minute": `\u5206\u949F`,
  "month": `\u6708`,
  "second": `\u79D2`,
  "selectedDateDescription": (args) => `\u9009\u5B9A\u7684\u65E5\u671F\uFF1A${args.date}`,
  "selectedRangeDescription": (args) => `\u9009\u5B9A\u7684\u8303\u56F4\uFF1A${args.startDate} \u81F3 ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u9009\u5B9A\u7684\u65F6\u95F4\uFF1A${args.time}`,
  "startDate": `\u5F00\u59CB\u65E5\u671F`,
  "timeZoneName": `\u65F6\u533A`,
  "weekday": `\u5DE5\u4F5C\u65E5`,
  "year": `\u5E74`
};
var $33fab8219207655a$exports = {};
$33fab8219207655a$exports = {
  "calendar": `\u65E5\u66C6`,
  "day": `\u65E5`,
  "dayPeriod": `\u4E0A\u5348/\u4E0B\u5348`,
  "endDate": `\u7D50\u675F\u65E5\u671F`,
  "era": `\u7EAA\u5143`,
  "hour": `\u5C0F\u65F6`,
  "minute": `\u5206\u949F`,
  "month": `\u6708`,
  "second": `\u79D2`,
  "selectedDateDescription": (args) => `\u9078\u5B9A\u7684\u65E5\u671F\uFF1A${args.date}`,
  "selectedRangeDescription": (args) => `\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A${args.startDate} \u81F3 ${args.endDate}`,
  "selectedTimeDescription": (args) => `\u9078\u5B9A\u7684\u6642\u9593\uFF1A${args.time}`,
  "startDate": `\u958B\u59CB\u65E5\u671F`,
  "timeZoneName": `\u65F6\u533A`,
  "weekday": `\u5DE5\u4F5C\u65E5`,
  "year": `\u5E74`
};
$204383cf4f6b0d06$exports = {
  "ar-AE": $f23889fffbde9058$exports,
  "bg-BG": $09d9badaa8903929$exports,
  "cs-CZ": $151b77e0fd711730$exports,
  "da-DK": $61915aa8630b90a2$exports,
  "de-DE": $35cea00159787840$exports,
  "el-GR": $518b4e82b9eacafd$exports,
  "en-US": $1c2b297f7e2cf474$exports,
  "es-ES": $07f628a707cf9b18$exports,
  "et-EE": $db553ffe17c7f4db$exports,
  "fi-FI": $4afcfe00cd703f83$exports,
  "fr-FR": $1d2645d18d4c5be0$exports,
  "he-IL": $64cb6a9be1f6fa48$exports,
  "hr-HR": $2a1ef2e8050be27a$exports,
  "hu-HU": $ad429dca102acd0e$exports,
  "it-IT": $6e68cb5d1cb97bd2$exports,
  "ja-JP": $a82ee9af063ee069$exports,
  "ko-KR": $67e9091dbf37d4eb$exports,
  "lt-LT": $75834f9729f653d1$exports,
  "lv-LV": $a2df2c2520b4a7f0$exports,
  "nb-NO": $aedcd71db4933ed5$exports,
  "nl-NL": $3b2df9e54353046c$exports,
  "pl-PL": $c03fe977fcfafe93$exports,
  "pt-BR": $569f006fc292345f$exports,
  "pt-PT": $7c2494e14452f2dd$exports,
  "ro-RO": $eb82ef981b5592bf$exports,
  "ru-RU": $6efa0e119f396950$exports,
  "sk-SK": $7f5e57085d7f5049$exports,
  "sl-SI": $578ee7c11dcdde7a$exports,
  "sr-SP": $bbc3fd6cd0bc9d50$exports,
  "sv-SE": $0b04512118591d2a$exports,
  "tr-TR": $3a49d121fe4c9e1d$exports,
  "uk-UA": $5ba21dbb8914919d$exports,
  "zh-CN": $51078838e1b16cd7$exports,
  "zh-TW": $33fab8219207655a$exports
};
function $3dfb0f96be0d6a08$export$4a931266a3838b86(state, ref1, disableArrowNavigation) {
  let { direction } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  let focusManager = useMemo(
    () => $9bf71ea28793e738$export$c5251b9e124bf29(ref1),
    [
      ref1
    ]
  );
  let onKeyDown = (e) => {
    if (e.altKey && (e.key === "ArrowDown" || e.key === "ArrowUp") && "setOpen" in state) {
      e.preventDefault();
      e.stopPropagation();
      state.setOpen(true);
    }
    if (disableArrowNavigation)
      return;
    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault();
        e.stopPropagation();
        if (direction === "rtl")
          focusManager.focusNext();
        else
          focusManager.focusPrevious();
        break;
      case "ArrowRight":
        e.preventDefault();
        e.stopPropagation();
        if (direction === "rtl")
          focusManager.focusPrevious();
        else
          focusManager.focusNext();
        break;
    }
  };
  let focusLast = () => {
    var ref;
    let target = (ref = window.event) === null || ref === void 0 ? void 0 : ref.target;
    let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ref1.current, {
      tabbable: true
    });
    if (target) {
      walker.currentNode = target;
      target = walker.previousNode();
    }
    if (!target) {
      let last;
      do {
        last = walker.lastChild();
        if (last)
          target = last;
      } while (last);
    }
    while (target === null || target === void 0 ? void 0 : target.hasAttribute("data-placeholder")) {
      let prev = walker.previousNode();
      if (prev && prev.hasAttribute("data-placeholder"))
        target = prev;
      else
        break;
    }
    if (target)
      target.focus();
  };
  let { pressProps } = $f6c31cce2adf654f$export$45712eceda6fad21({
    preventFocusOnPress: true,
    allowTextSelectionOnPress: true,
    onPressStart(e) {
      if (e.pointerType === "mouse")
        focusLast();
    },
    onPress(e) {
      if (e.pointerType !== "mouse")
        focusLast();
    }
  });
  return $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, {
    onKeyDown
  });
}
var $16f0b7bb276bc17e$export$653eddfc964b0f8a = /* @__PURE__ */ new WeakMap();
var $16f0b7bb276bc17e$export$300019f83c56d282 = "__role_" + Date.now();
var $16f0b7bb276bc17e$export$7b3062cd49e80452 = "__focusManager_" + Date.now();
function $16f0b7bb276bc17e$export$5591b0b878c1a989(props, state, ref) {
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...props,
    labelElementType: "span"
  });
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    onBlurWithin() {
      state.confirmPlaceholder();
    }
  });
  let stringFormatter = $fca6afa0e843324b$export$f12b703ca79dfbb1(/* @__PURE__ */ $parcel$interopDefault2($204383cf4f6b0d06$exports));
  let message = state.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription";
  let field = state.maxGranularity === "hour" ? "time" : "date";
  let description = state.value ? stringFormatter.format(message, {
    [field]: state.formatValue({
      month: "long"
    })
  }) : "";
  let descProps = $ef06256079686ba0$export$f8aeda7b10753fa1(description);
  let describedBy = props[$16f0b7bb276bc17e$export$300019f83c56d282] === "presentation" ? fieldProps["aria-describedby"] : [
    descProps["aria-describedby"],
    fieldProps["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0;
  let propsFocusManager = props[$16f0b7bb276bc17e$export$7b3062cd49e80452];
  let focusManager = useMemo(
    () => propsFocusManager || $9bf71ea28793e738$export$c5251b9e124bf29(ref),
    [
      propsFocusManager,
      ref
    ]
  );
  let groupProps = $3dfb0f96be0d6a08$export$4a931266a3838b86(state, ref, props[$16f0b7bb276bc17e$export$300019f83c56d282] === "presentation");
  $16f0b7bb276bc17e$export$653eddfc964b0f8a.set(state, {
    ariaLabel: props["aria-label"],
    ariaLabelledBy: [
      props["aria-labelledby"],
      labelProps.id
    ].filter(Boolean).join(" ") || void 0,
    ariaDescribedBy: describedBy,
    focusManager
  });
  let autoFocusRef = useRef(props.autoFocus);
  let fieldDOMProps;
  if (props[$16f0b7bb276bc17e$export$300019f83c56d282] === "presentation")
    fieldDOMProps = {
      role: "presentation"
    };
  else
    fieldDOMProps = $3ef42575df84b30b$export$9d1611c77c2fe928(fieldProps, {
      role: "group",
      "aria-disabled": props.isDisabled || void 0,
      "aria-describedby": describedBy
    });
  useEffect(() => {
    if (autoFocusRef.current)
      focusManager.focusFirst();
    autoFocusRef.current = false;
  }, [
    focusManager
  ]);
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);
  return {
    labelProps: {
      ...labelProps,
      onClick: () => {
        focusManager.focusFirst();
      }
    },
    fieldProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, fieldDOMProps, groupProps, focusWithinProps),
    descriptionProps,
    errorMessageProps
  };
}
function $6057a3d2a53a12fd$export$42df105a73306d51(props, state, ref) {
  let buttonId = $bdb11010cef70236$export$f680877a34711e37();
  let dialogId = $bdb11010cef70236$export$f680877a34711e37();
  let stringFormatter = $fca6afa0e843324b$export$f12b703ca79dfbb1(/* @__PURE__ */ $parcel$interopDefault2($204383cf4f6b0d06$exports));
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...props,
    labelElementType: "span"
  });
  let groupProps = $3dfb0f96be0d6a08$export$4a931266a3838b86(state, ref);
  let labelledBy = fieldProps["aria-labelledby"] || fieldProps.id;
  let { locale } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  let date = state.formatValue(locale, {
    month: "long"
  });
  let description = date ? stringFormatter.format("selectedDateDescription", {
    date
  }) : "";
  let descProps = $ef06256079686ba0$export$f8aeda7b10753fa1(description);
  let ariaDescribedBy = [
    descProps["aria-describedby"],
    fieldProps["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0;
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);
  let focusManager = useMemo(
    () => $9bf71ea28793e738$export$c5251b9e124bf29(ref),
    [
      ref
    ]
  );
  return {
    groupProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, groupProps, fieldProps, descProps, {
      role: "group",
      "aria-disabled": props.isDisabled || null,
      "aria-labelledby": labelledBy,
      "aria-describedby": ariaDescribedBy
    }),
    labelProps: {
      ...labelProps,
      onClick: () => {
        focusManager.focusFirst();
      }
    },
    fieldProps: {
      ...fieldProps,
      [$16f0b7bb276bc17e$export$300019f83c56d282]: "presentation",
      "aria-describedby": ariaDescribedBy,
      value: state.value,
      onChange: state.setValue,
      minValue: props.minValue,
      maxValue: props.maxValue,
      placeholderValue: props.placeholderValue,
      hideTimeZone: props.hideTimeZone,
      hourCycle: props.hourCycle,
      granularity: props.granularity,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      isRequired: props.isRequired,
      validationState: state.validationState,
      autoFocus: props.autoFocus
    },
    descriptionProps,
    errorMessageProps,
    buttonProps: {
      ...descProps,
      id: buttonId,
      "aria-haspopup": "dialog",
      "aria-label": stringFormatter.format("calendar"),
      "aria-labelledby": `${labelledBy} ${buttonId}`,
      "aria-describedby": ariaDescribedBy,
      onPress: () => state.setOpen(true)
    },
    dialogProps: {
      id: dialogId,
      "aria-labelledby": `${labelledBy} ${buttonId}`
    },
    calendarProps: {
      autoFocus: true,
      value: state.dateValue,
      onChange: state.setDateValue,
      minValue: props.minValue,
      maxValue: props.maxValue,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      isDateUnavailable: props.isDateUnavailable,
      defaultFocusedValue: state.dateValue ? void 0 : props.placeholderValue,
      validationState: state.validationState,
      errorMessage: props.errorMessage
    }
  };
}
function $3aeceb3a64eb8358$export$d42c60378c8168f8() {
  let { locale } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  return useMemo(() => {
    try {
      return new Intl.DisplayNames(locale, {
        type: "dateTimeField"
      });
    } catch (err) {
      return new $3aeceb3a64eb8358$var$DisplayNamesPolyfill(locale);
    }
  }, [
    locale
  ]);
}
var $3aeceb3a64eb8358$var$DisplayNamesPolyfill = class {
  of(field) {
    return this.dictionary.getStringForLocale(field, this.locale);
  }
  constructor(locale) {
    this.locale = locale;
    this.dictionary = new $5b160d28a433310d$export$c17fa47878dc55b6(/* @__PURE__ */ $parcel$interopDefault2($204383cf4f6b0d06$exports));
  }
};
function $32489daedd52963e$export$1315d136e6f7581(segment, state, ref) {
  let enteredKeys = useRef("");
  let { locale } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  let displayNames = $3aeceb3a64eb8358$export$d42c60378c8168f8();
  let { ariaLabel, ariaLabelledBy, ariaDescribedBy, focusManager } = $16f0b7bb276bc17e$export$653eddfc964b0f8a.get(state);
  let textValue = segment.isPlaceholder ? "" : segment.text;
  let options = useMemo(
    () => state.dateFormatter.resolvedOptions(),
    [
      state.dateFormatter
    ]
  );
  let monthDateFormatter = $896ba0a80a8f4d36$export$85fd5fdf27bacc79({
    month: "long",
    timeZone: options.timeZone
  });
  let hourDateFormatter = $896ba0a80a8f4d36$export$85fd5fdf27bacc79({
    hour: "numeric",
    hour12: options.hour12,
    timeZone: options.timeZone
  });
  if (segment.type === "month" && !segment.isPlaceholder) {
    let monthTextValue = monthDateFormatter.format(state.dateValue);
    textValue = monthTextValue !== textValue ? `${textValue} \u2013 ${monthTextValue}` : monthTextValue;
  } else if (segment.type === "hour" && !segment.isPlaceholder)
    textValue = hourDateFormatter.format(state.dateValue);
  let { spinButtonProps } = $d2e8511e6f209edf$export$e908e06f4b8e3402({
    value: segment.value,
    textValue,
    minValue: segment.minValue,
    maxValue: segment.maxValue,
    isDisabled: state.isDisabled,
    isReadOnly: state.isReadOnly || !segment.isEditable,
    isRequired: state.isRequired,
    onIncrement: () => {
      enteredKeys.current = "";
      state.increment(segment.type);
    },
    onDecrement: () => {
      enteredKeys.current = "";
      state.decrement(segment.type);
    },
    onIncrementPage: () => {
      enteredKeys.current = "";
      state.incrementPage(segment.type);
    },
    onDecrementPage: () => {
      enteredKeys.current = "";
      state.decrementPage(segment.type);
    },
    onIncrementToMax: () => {
      enteredKeys.current = "";
      state.setSegment(segment.type, segment.maxValue);
    },
    onDecrementToMin: () => {
      enteredKeys.current = "";
      state.setSegment(segment.type, segment.minValue);
    }
  });
  let parser = useMemo(
    () => new $6c7bd7858deea686$export$cd11ab140839f11d(locale, {
      maximumFractionDigits: 0
    }),
    [
      locale
    ]
  );
  let backspace = () => {
    if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly && !segment.isPlaceholder) {
      let newValue = segment.text.slice(0, -1);
      let parsed = parser.parse(newValue);
      if (newValue.length === 0 || parsed === 0)
        state.clearSegment(segment.type);
      else
        state.setSegment(segment.type, parsed);
      enteredKeys.current = newValue;
    } else if (segment.type === "dayPeriod")
      state.clearSegment(segment.type);
  };
  let onKeyDown = (e) => {
    if (e.key === "a" && ($c87311424ea30a05$export$9ac100e40613ea10() ? e.metaKey : e.ctrlKey))
      e.preventDefault();
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)
      return;
    switch (e.key) {
      case "Backspace":
      case "Delete":
        e.preventDefault();
        e.stopPropagation();
        backspace();
        break;
    }
  };
  let { startsWith } = $bb77f239b46e8c72$export$3274cf84b703fff({
    sensitivity: "base"
  });
  let amPmFormatter = $896ba0a80a8f4d36$export$85fd5fdf27bacc79({
    hour: "numeric",
    hour12: true
  });
  let am = useMemo(() => {
    let date = new Date();
    date.setHours(0);
    return amPmFormatter.formatToParts(date).find(
      (part) => part.type === "dayPeriod"
    ).value;
  }, [
    amPmFormatter
  ]);
  let pm = useMemo(() => {
    let date = new Date();
    date.setHours(12);
    return amPmFormatter.formatToParts(date).find(
      (part) => part.type === "dayPeriod"
    ).value;
  }, [
    amPmFormatter
  ]);
  let eraFormatter = $896ba0a80a8f4d36$export$85fd5fdf27bacc79({
    year: "numeric",
    era: "narrow",
    timeZone: "UTC"
  });
  let eras1 = useMemo(() => {
    if (segment.type !== "era")
      return [];
    let date = toCalendar(new CalendarDate(1, 1, 1), state.calendar);
    let eras = state.calendar.getEras().map((era) => {
      let eraDate = date.set({
        year: 1,
        month: 1,
        day: 1,
        era
      }).toDate("UTC");
      let parts = eraFormatter.formatToParts(eraDate);
      let formatted = parts.find(
        (p) => p.type === "era"
      ).value;
      return {
        era,
        formatted
      };
    });
    let prefixLength = $32489daedd52963e$var$commonPrefixLength(eras.map(
      (era) => era.formatted
    ));
    if (prefixLength)
      for (let era1 of eras)
        era1.formatted = era1.formatted.slice(prefixLength);
    return eras;
  }, [
    eraFormatter,
    state.calendar,
    segment.type
  ]);
  let onInput = (key) => {
    if (state.isDisabled || state.isReadOnly)
      return;
    let newValue = enteredKeys.current + key;
    switch (segment.type) {
      case "dayPeriod":
        if (startsWith(am, key))
          state.setSegment("dayPeriod", 0);
        else if (startsWith(pm, key))
          state.setSegment("dayPeriod", 12);
        else
          break;
        focusManager.focusNext();
        break;
      case "era": {
        let matched = eras1.find(
          (e) => startsWith(e.formatted, key)
        );
        if (matched) {
          state.setSegment("era", matched.era);
          focusManager.focusNext();
        }
        break;
      }
      case "day":
      case "hour":
      case "minute":
      case "second":
      case "month":
      case "year": {
        if (!parser.isValidPartialNumber(newValue))
          return;
        let numberValue = parser.parse(newValue);
        let segmentValue = numberValue;
        let allowsZero = segment.minValue === 0;
        if (segment.type === "hour" && state.dateFormatter.resolvedOptions().hour12) {
          switch (state.dateFormatter.resolvedOptions().hourCycle) {
            case "h11":
              if (numberValue > 11)
                segmentValue = parser.parse(key);
              break;
            case "h12":
              allowsZero = false;
              if (numberValue > 12)
                segmentValue = parser.parse(key);
              break;
          }
          if (segment.value >= 12 && numberValue > 1)
            numberValue += 12;
        } else if (numberValue > segment.maxValue)
          segmentValue = parser.parse(key);
        if (isNaN(numberValue))
          return;
        let shouldSetValue = segmentValue !== 0 || allowsZero;
        if (shouldSetValue)
          state.setSegment(segment.type, segmentValue);
        if (Number(numberValue + "0") > segment.maxValue || newValue.length >= String(segment.maxValue).length) {
          enteredKeys.current = "";
          if (shouldSetValue)
            focusManager.focusNext();
        } else
          enteredKeys.current = newValue;
        break;
      }
    }
  };
  let onFocus = () => {
    enteredKeys.current = "";
    $2f04cbc44ee30ce0$export$53a0910f038337bd($62d8ded9296f3872$export$cfa2225e87938781(ref.current), ref.current);
    let selection = window.getSelection();
    selection.collapse(ref.current);
  };
  let compositionRef = useRef("");
  $e9faafb641e167db$export$90fc3a17d93f704c(ref, "beforeinput", (e) => {
    e.preventDefault();
    switch (e.inputType) {
      case "deleteContentBackward":
      case "deleteContentForward":
        if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly)
          backspace();
        break;
      case "insertCompositionText":
        compositionRef.current = ref.current.textContent;
        ref.current.textContent = ref.current.textContent;
        break;
      default:
        if (e.data != null)
          onInput(e.data);
        break;
    }
  });
  $e9faafb641e167db$export$90fc3a17d93f704c(ref, "input", (e) => {
    let { inputType, data } = e;
    switch (inputType) {
      case "insertCompositionText":
        ref.current.textContent = compositionRef.current;
        if (startsWith(am, data) || startsWith(pm, data))
          onInput(data);
        break;
    }
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let element = ref.current;
    return () => {
      if (document.activeElement === element) {
        let prev = focusManager.focusPrevious();
        if (!prev)
          focusManager.focusNext();
      }
    };
  }, [
    ref,
    focusManager
  ]);
  let touchPropOverrides = $c87311424ea30a05$export$fedb369cb70207f1() || segment.type === "timeZoneName" ? {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuetext": null,
    "aria-valuenow": null
  } : {};
  let firstSegment = useMemo(
    () => state.segments.find(
      (s) => s.isEditable
    ),
    [
      state.segments
    ]
  );
  if (segment !== firstSegment && state.validationState !== "invalid")
    ariaDescribedBy = void 0;
  let id = $bdb11010cef70236$export$f680877a34711e37();
  let isEditable = !state.isDisabled && !state.isReadOnly && segment.isEditable;
  let name = segment.type === "literal" ? "" : displayNames.of(segment.type);
  let labelProps = $313b98861ee5dd6c$export$d6875122194c7b44({
    "aria-label": (ariaLabel ? ariaLabel + " " : "") + name,
    "aria-labelledby": ariaLabelledBy
  });
  if (segment.type === "literal")
    return {
      segmentProps: {
        "aria-hidden": true
      }
    };
  return {
    segmentProps: $3ef42575df84b30b$export$9d1611c77c2fe928(spinButtonProps, labelProps, {
      id,
      ...touchPropOverrides,
      "aria-invalid": state.validationState === "invalid" ? "true" : void 0,
      "aria-describedby": ariaDescribedBy,
      "aria-readonly": state.isReadOnly || !segment.isEditable ? "true" : void 0,
      "data-placeholder": segment.isPlaceholder || void 0,
      contentEditable: isEditable,
      suppressContentEditableWarning: isEditable,
      spellCheck: isEditable ? "false" : void 0,
      autoCapitalize: isEditable ? "off" : void 0,
      autoCorrect: isEditable ? "off" : void 0,
      [parseInt(React.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: isEditable ? "next" : void 0,
      inputMode: state.isDisabled || segment.type === "dayPeriod" || segment.type === "era" || !isEditable ? void 0 : "numeric",
      tabIndex: state.isDisabled ? void 0 : 0,
      onKeyDown,
      onFocus,
      style: {
        caretColor: "transparent"
      },
      onPointerDown(e) {
        e.stopPropagation();
      },
      onMouseDown(e) {
        e.stopPropagation();
      }
    })
  };
}
function $32489daedd52963e$var$commonPrefixLength(strings) {
  strings.sort();
  let first = strings[0];
  let last = strings[strings.length - 1];
  for (let i = 0; i < first.length; i++) {
    if (first[i] !== last[i])
      return i;
  }
  return 0;
}
function $887cac91b7cc8801$export$12fd5f0e9f4bb192(props, state, ref) {
  var ref1, ref2;
  let stringFormatter = $fca6afa0e843324b$export$f12b703ca79dfbb1(/* @__PURE__ */ $parcel$interopDefault2($204383cf4f6b0d06$exports));
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...props,
    labelElementType: "span"
  });
  let labelledBy = fieldProps["aria-labelledby"] || fieldProps.id;
  let { locale } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  let range = state.formatValue(locale, {
    month: "long"
  });
  let description = range ? stringFormatter.format("selectedRangeDescription", {
    startDate: range.start,
    endDate: range.end
  }) : "";
  let descProps = $ef06256079686ba0$export$f8aeda7b10753fa1(description);
  let startFieldProps = {
    "aria-label": stringFormatter.format("startDate"),
    "aria-labelledby": labelledBy
  };
  let endFieldProps = {
    "aria-label": stringFormatter.format("endDate"),
    "aria-labelledby": labelledBy
  };
  let buttonId = $bdb11010cef70236$export$f680877a34711e37();
  let dialogId = $bdb11010cef70236$export$f680877a34711e37();
  let groupProps = $3dfb0f96be0d6a08$export$4a931266a3838b86(state, ref);
  let ariaDescribedBy = [
    descProps["aria-describedby"],
    fieldProps["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0;
  let focusManager = useMemo(
    () => $9bf71ea28793e738$export$c5251b9e124bf29(ref, {
      accept: (element) => element.id !== buttonId
    }),
    [
      ref,
      buttonId
    ]
  );
  let commonFieldProps = {
    [$16f0b7bb276bc17e$export$7b3062cd49e80452]: focusManager,
    [$16f0b7bb276bc17e$export$300019f83c56d282]: "presentation",
    "aria-describedby": ariaDescribedBy,
    minValue: props.minValue,
    maxValue: props.maxValue,
    placeholderValue: props.placeholderValue,
    hideTimeZone: props.hideTimeZone,
    hourCycle: props.hourCycle,
    granularity: props.granularity,
    isDisabled: props.isDisabled,
    isReadOnly: props.isReadOnly,
    isRequired: props.isRequired,
    validationState: state.validationState
  };
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);
  return {
    groupProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, groupProps, fieldProps, descProps, {
      role: "group",
      "aria-disabled": props.isDisabled || null,
      "aria-describedby": ariaDescribedBy
    }),
    labelProps: {
      ...labelProps,
      onClick: () => {
        focusManager.focusFirst();
      }
    },
    buttonProps: {
      ...descProps,
      id: buttonId,
      "aria-haspopup": "dialog",
      "aria-label": stringFormatter.format("calendar"),
      "aria-labelledby": `${labelledBy} ${buttonId}`,
      "aria-describedby": ariaDescribedBy,
      onPress: () => state.setOpen(true)
    },
    dialogProps: {
      id: dialogId,
      "aria-labelledby": `${labelledBy} ${buttonId}`
    },
    startFieldProps: {
      ...startFieldProps,
      ...commonFieldProps,
      value: (ref1 = state.value) === null || ref1 === void 0 ? void 0 : ref1.start,
      onChange: (start) => state.setDateTime("start", start),
      autoFocus: props.autoFocus
    },
    endFieldProps: {
      ...endFieldProps,
      ...commonFieldProps,
      value: (ref2 = state.value) === null || ref2 === void 0 ? void 0 : ref2.end,
      onChange: (end) => state.setDateTime("end", end)
    },
    descriptionProps,
    errorMessageProps,
    calendarProps: {
      autoFocus: true,
      value: state.dateRange,
      onChange: state.setDateRange,
      minValue: props.minValue,
      maxValue: props.maxValue,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      isDateUnavailable: props.isDateUnavailable,
      allowsNonContiguousRanges: props.allowsNonContiguousRanges,
      defaultFocusedValue: state.dateRange ? void 0 : props.placeholderValue,
      validationState: state.validationState,
      errorMessage: props.errorMessage
    }
  };
}

// ../../node_modules/@react-stately/overlays/dist/module.js
function $fc909762b330b746$export$61c6a8c84e605fb6(props) {
  let [isOpen, setOpen] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isOpen, props.defaultOpen || false, props.onOpenChange);
  return {
    isOpen,
    setOpen,
    open() {
      setOpen(true);
    },
    close() {
      setOpen(false);
    },
    toggle() {
      setOpen(!isOpen);
    }
  };
}
function $35a22f14a1f04b11$export$eac50920cf2fd59a(value, minValue, maxValue) {
  return value != null && (minValue != null && value.compare(minValue) < 0 || maxValue != null && value.compare(maxValue) > 0);
}
var $35a22f14a1f04b11$var$DEFAULT_FIELD_OPTIONS = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
};
function $35a22f14a1f04b11$export$7e319ea407e63bc0(fieldOptions, options) {
  fieldOptions = {
    ...$35a22f14a1f04b11$var$DEFAULT_FIELD_OPTIONS,
    ...fieldOptions
  };
  let granularity = options.granularity || "minute";
  let keys = Object.keys(fieldOptions);
  var _maxGranularity;
  let startIdx = keys.indexOf((_maxGranularity = options.maxGranularity) !== null && _maxGranularity !== void 0 ? _maxGranularity : "year");
  if (startIdx < 0)
    startIdx = 0;
  let endIdx = keys.indexOf(granularity);
  if (endIdx < 0)
    endIdx = 2;
  if (startIdx > endIdx)
    throw new Error("maxGranularity must be greater than granularity");
  let opts1 = keys.slice(startIdx, endIdx + 1).reduce((opts, key) => {
    opts[key] = fieldOptions[key];
    return opts;
  }, {});
  if (options.hourCycle != null)
    opts1.hour12 = options.hourCycle === 12;
  opts1.timeZone = options.timeZone || "UTC";
  let hasTime = granularity === "hour" || granularity === "minute" || granularity === "second";
  if (hasTime && options.timeZone && !options.hideTimeZone)
    opts1.timeZoneName = "short";
  if (options.showEra && startIdx === 0)
    opts1.era = "short";
  return opts1;
}
function $35a22f14a1f04b11$export$c5221a78ef73c5e9(placeholderValue) {
  if (placeholderValue && "hour" in placeholderValue)
    return placeholderValue;
  return new Time();
}
function $35a22f14a1f04b11$export$61a490a80c552550(value, calendar) {
  if (value === null)
    return null;
  if (!value)
    return void 0;
  return toCalendar(value, calendar);
}
function $35a22f14a1f04b11$export$66aa2b09de4b1ea5(placeholderValue, granularity, calendar, timeZone) {
  if (placeholderValue)
    return $35a22f14a1f04b11$export$61a490a80c552550(placeholderValue, calendar);
  let date = toCalendar(now(timeZone).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }), calendar);
  if (granularity === "year" || granularity === "month" || granularity === "day")
    return toCalendarDate(date);
  if (!timeZone)
    return toCalendarDateTime(date);
  return date;
}
function $35a22f14a1f04b11$export$2440da353cedad43(v, granularity) {
  let lastValue = useRef(v);
  if (v)
    lastValue.current = v;
  v = lastValue.current;
  let defaultTimeZone = v && "timeZone" in v ? v.timeZone : void 0;
  granularity = granularity || (v && "minute" in v ? "minute" : "day");
  if (v && !(granularity in v))
    throw new Error("Invalid granularity " + granularity + " for value " + v.toString());
  return [
    granularity,
    defaultTimeZone
  ];
}
function $ab5bf3f618090389$export$87194bb378cc3ac2(props) {
  var ref;
  let overlayState = $fc909762b330b746$export$61c6a8c84e605fb6(props);
  let [value, setValue] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, props.defaultValue || null, props.onChange);
  let v = value || props.placeholderValue;
  let [granularity, defaultTimeZone] = $35a22f14a1f04b11$export$2440da353cedad43(v, props.granularity);
  let dateValue = value != null ? value.toDate(defaultTimeZone !== null && defaultTimeZone !== void 0 ? defaultTimeZone : "UTC") : null;
  let hasTime = granularity === "hour" || granularity === "minute" || granularity === "second" || granularity === "millisecond";
  var _shouldCloseOnSelect;
  let shouldCloseOnSelect = (_shouldCloseOnSelect = props.shouldCloseOnSelect) !== null && _shouldCloseOnSelect !== void 0 ? _shouldCloseOnSelect : true;
  let [selectedDate, setSelectedDate] = useState(null);
  let [selectedTime, setSelectedTime] = useState(null);
  if (value) {
    selectedDate = value;
    if ("hour" in value)
      selectedTime = value;
  }
  if (v && !(granularity in v))
    throw new Error("Invalid granularity " + granularity + " for value " + v.toString());
  let commitValue = (date, time) => {
    setValue("timeZone" in time ? time.set(toCalendarDate(date)) : toCalendarDateTime(date, time));
  };
  let selectDate = (newValue) => {
    let shouldClose = typeof shouldCloseOnSelect === "function" ? shouldCloseOnSelect() : shouldCloseOnSelect;
    if (hasTime) {
      if (selectedTime || shouldClose)
        commitValue(newValue, selectedTime || $35a22f14a1f04b11$export$c5221a78ef73c5e9(props.placeholderValue));
      else
        setSelectedDate(newValue);
    } else
      setValue(newValue);
    if (shouldClose)
      overlayState.setOpen(false);
  };
  let selectTime = (newValue) => {
    if (selectedDate)
      commitValue(selectedDate, newValue);
    else
      setSelectedTime(newValue);
  };
  let validationState = props.validationState || ($35a22f14a1f04b11$export$eac50920cf2fd59a(value, props.minValue, props.maxValue) ? "invalid" : null) || (value && ((ref = props.isDateUnavailable) === null || ref === void 0 ? void 0 : ref.call(props, value)) ? "invalid" : null);
  return {
    value,
    setValue,
    dateValue: selectedDate,
    timeValue: selectedTime,
    setDateValue: selectDate,
    setTimeValue: selectTime,
    granularity,
    hasTime,
    isOpen: overlayState.isOpen,
    setOpen(isOpen) {
      if (!isOpen && !value && selectedDate && hasTime)
        commitValue(selectedDate, selectedTime || $35a22f14a1f04b11$export$c5221a78ef73c5e9(props.placeholderValue));
      overlayState.setOpen(isOpen);
    },
    validationState,
    formatValue(locale, fieldOptions) {
      if (!dateValue)
        return "";
      let formatOptions = $35a22f14a1f04b11$export$7e319ea407e63bc0(fieldOptions, {
        granularity,
        timeZone: defaultTimeZone,
        hideTimeZone: props.hideTimeZone,
        hourCycle: props.hourCycle,
        showEra: value.calendar.identifier === "gregory" && value.era === "BC"
      });
      let formatter = new DateFormatter(locale, formatOptions);
      return formatter.format(dateValue);
    }
  };
}
var $3e3ed55ab2966714$var$placeholders = new $5b160d28a433310d$export$c17fa47878dc55b6({
  ach: {
    year: "mwaka",
    month: "dwe",
    day: "nino"
  },
  af: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  am: {
    year: "\u12D3\u12D3\u12D3\u12D3",
    month: "\u121A\u121C",
    day: "\u1240\u1240"
  },
  an: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ar: {
    year: "\u0633\u0646\u0629",
    month: "\u0634\u0647\u0631",
    day: "\u064A\u0648\u0645"
  },
  ast: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  az: {
    year: "iiii",
    month: "aa",
    day: "gg"
  },
  be: {
    year: "\u0433\u0433\u0433\u0433",
    month: "\u043C\u043C",
    day: "\u0434\u0434"
  },
  bg: {
    year: "\u0433\u0433\u0433\u0433",
    month: "\u043C\u043C",
    day: "\u0434\u0434"
  },
  bn: {
    year: "yyyy",
    month: "\u09AE\u09BF\u09AE\u09BF",
    day: "dd"
  },
  br: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  bs: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  ca: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  cak: {
    year: "jjjj",
    month: "ii",
    day: "q'q'"
  },
  ckb: {
    year: "\u0633\u0627\u06B5",
    month: "\u0645\u0627\u0646\u06AF",
    day: "\u0695\u06C6\u0698"
  },
  cs: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  cy: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  da: {
    year: "\xE5\xE5\xE5\xE5",
    month: "mm",
    day: "dd"
  },
  de: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  dsb: {
    year: "llll",
    month: "mm",
    day: "\u017A\u017A"
  },
  el: {
    year: "\u03B5\u03B5\u03B5\u03B5",
    month: "\u03BC\u03BC",
    day: "\u03B7\u03B7"
  },
  en: {
    year: "yyyy",
    month: "mm",
    day: "dd"
  },
  eo: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  es: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  et: {
    year: "aaaa",
    month: "kk",
    day: "pp"
  },
  eu: {
    year: "uuuu",
    month: "hh",
    day: "ee"
  },
  fa: {
    year: "\u0633\u0627\u0644",
    month: "\u0645\u0627\u0647",
    day: "\u0631\u0648\u0632"
  },
  ff: {
    year: "hhhh",
    month: "ll",
    day: "\xF1\xF1"
  },
  fi: {
    year: "vvvv",
    month: "kk",
    day: "pp"
  },
  fr: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  fy: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  ga: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gd: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gl: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  he: {
    year: "\u05E9\u05E0\u05D4",
    month: "\u05D7\u05D5\u05D3\u05E9",
    day: "\u05D9\u05D5\u05DD"
  },
  hr: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  hsb: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  hu: {
    year: "\xE9\xE9\xE9\xE9",
    month: "hh",
    day: "nn"
  },
  ia: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  id: {
    year: "tttt",
    month: "bb",
    day: "hh"
  },
  it: {
    year: "aaaa",
    month: "mm",
    day: "gg"
  },
  ja: {
    year: " \u5E74 ",
    month: "\u6708",
    day: "\u65E5"
  },
  ka: {
    year: "\u10EC\u10EC\u10EC\u10EC",
    month: "\u10D7\u10D7",
    day: "\u10E0\u10E0"
  },
  kk: {
    year: "\u0436\u0436\u0436\u0436",
    month: "\u0430\u0430",
    day: "\u043A\u043A"
  },
  kn: {
    year: "\u0CB5\u0CB5\u0CB5\u0CB5",
    month: "\u0CAE\u0CBF\u0CAE\u0CC0",
    day: "\u0CA6\u0CBF\u0CA6\u0CBF"
  },
  ko: {
    year: "\uC5F0\uB3C4",
    month: "\uC6D4",
    day: "\uC77C"
  },
  lb: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  lo: {
    year: "\u0E9B\u0E9B\u0E9B\u0E9B",
    month: "\u0E94\u0E94",
    day: "\u0EA7\u0EA7"
  },
  lt: {
    year: "mmmm",
    month: "mm",
    day: "dd"
  },
  lv: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  meh: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ml: {
    year: "\u0D35\u0D7C\u0D37\u0D02",
    month: "\u0D2E\u0D3E\u0D38\u0D02",
    day: "\u0D24\u0D40\u0D2F\u0D24\u0D3F"
  },
  ms: {
    year: "tttt",
    month: "mm",
    day: "hh"
  },
  nl: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  nn: {
    year: "\xE5\xE5\xE5\xE5",
    month: "mm",
    day: "dd"
  },
  no: {
    year: "\xE5\xE5\xE5\xE5",
    month: "mm",
    day: "dd"
  },
  oc: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  pl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  pt: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  rm: {
    year: "oooo",
    month: "mm",
    day: "dd"
  },
  ro: {
    year: "aaaa",
    month: "ll",
    day: "zz"
  },
  ru: {
    year: "\u0433\u0433\u0433\u0433",
    month: "\u043C\u043C",
    day: "\u0434\u0434"
  },
  sc: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  scn: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  sk: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  sl: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  sr: {
    year: "\u0433\u0433\u0433\u0433",
    month: "\u043C\u043C",
    day: "\u0434\u0434"
  },
  sv: {
    year: "\xE5\xE5\xE5\xE5",
    month: "mm",
    day: "dd"
  },
  szl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  tg: {
    year: "\u0441\u0441\u0441\u0441",
    month: "\u043C\u043C",
    day: "\u0440\u0440"
  },
  th: {
    year: "\u0E1B\u0E1B\u0E1B\u0E1B",
    month: "\u0E14\u0E14",
    day: "\u0E27\u0E27"
  },
  tr: {
    year: "yyyy",
    month: "aa",
    day: "gg"
  },
  uk: {
    year: "\u0440\u0440\u0440\u0440",
    month: "\u043C\u043C",
    day: "\u0434\u0434"
  },
  "zh-CN": {
    year: "\u5E74",
    month: "\u6708",
    day: "\u65E5"
  },
  "zh-TW": {
    year: "\u5E74",
    month: "\u6708",
    day: "\u65E5"
  }
}, "en");
function $3e3ed55ab2966714$export$d3f5c5e0a5023fa0(field, value, locale) {
  if (field === "era" || field === "dayPeriod")
    return value;
  if (field === "year" || field === "month" || field === "day")
    return $3e3ed55ab2966714$var$placeholders.getStringForLocale(field, locale);
  return "\u2013\u2013";
}
var $3c0fc76039f1c516$var$EDITABLE_SEGMENTS = {
  year: true,
  month: true,
  day: true,
  hour: true,
  minute: true,
  second: true,
  dayPeriod: true,
  era: true
};
var $3c0fc76039f1c516$var$PAGE_STEP = {
  year: 5,
  month: 2,
  day: 7,
  hour: 2,
  minute: 15,
  second: 15
};
var $3c0fc76039f1c516$var$TYPE_MAPPING = {
  dayperiod: "dayPeriod"
};
function $3c0fc76039f1c516$export$60e84778edff6d26(props) {
  let { locale, createCalendar: createCalendar2, hideTimeZone, isDisabled, isReadOnly, isRequired } = props;
  let v1 = props.value || props.defaultValue || props.placeholderValue;
  let [granularity, defaultTimeZone] = $35a22f14a1f04b11$export$2440da353cedad43(v1, props.granularity);
  let timeZone = defaultTimeZone || "UTC";
  if (v1 && !(granularity in v1))
    throw new Error("Invalid granularity " + granularity + " for value " + v1.toString());
  let defaultFormatter = useMemo(
    () => new DateFormatter(locale),
    [
      locale
    ]
  );
  let calendar = useMemo(
    () => createCalendar2(defaultFormatter.resolvedOptions().calendar),
    [
      createCalendar2,
      defaultFormatter
    ]
  );
  let [value1, setDate] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, props.defaultValue, props.onChange);
  let calendarValue = useMemo(
    () => $35a22f14a1f04b11$export$61a490a80c552550(value1, calendar),
    [
      value1,
      calendar
    ]
  );
  let [placeholderDate, setPlaceholderDate] = useState(
    () => $35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue, granularity, calendar, defaultTimeZone)
  );
  let val = calendarValue || placeholderDate;
  let showEra = calendar.identifier === "gregory" && val.era === "BC";
  var _maxGranularity;
  let formatOpts = useMemo(
    () => ({
      granularity,
      maxGranularity: (_maxGranularity = props.maxGranularity) !== null && _maxGranularity !== void 0 ? _maxGranularity : "year",
      timeZone: defaultTimeZone,
      hideTimeZone,
      hourCycle: props.hourCycle,
      showEra
    }),
    [
      props.maxGranularity,
      granularity,
      props.hourCycle,
      defaultTimeZone,
      hideTimeZone,
      showEra
    ]
  );
  let opts = useMemo(
    () => $35a22f14a1f04b11$export$7e319ea407e63bc0({}, formatOpts),
    [
      formatOpts
    ]
  );
  let dateFormatter = useMemo(
    () => new DateFormatter(locale, opts),
    [
      locale,
      opts
    ]
  );
  let resolvedOptions = useMemo(
    () => dateFormatter.resolvedOptions(),
    [
      dateFormatter
    ]
  );
  let allSegments = useMemo(
    () => dateFormatter.formatToParts(new Date()).filter(
      (seg) => $3c0fc76039f1c516$var$EDITABLE_SEGMENTS[seg.type]
    ).reduce(
      (p, seg) => (p[seg.type] = true, p),
      {}
    ),
    [
      dateFormatter
    ]
  );
  let [validSegments, setValidSegments] = useState(
    () => props.value || props.defaultValue ? {
      ...allSegments
    } : {}
  );
  let lastCalendarIdentifier = useRef(calendar.identifier);
  useEffect(() => {
    if (calendar.identifier !== lastCalendarIdentifier.current) {
      lastCalendarIdentifier.current = calendar.identifier;
      setPlaceholderDate(
        (placeholder) => Object.keys(validSegments).length > 0 ? toCalendar(placeholder, calendar) : $35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue, granularity, calendar, defaultTimeZone)
      );
    }
  }, [
    calendar,
    granularity,
    validSegments,
    defaultTimeZone,
    props.placeholderValue
  ]);
  if (value1 && Object.keys(validSegments).length < Object.keys(allSegments).length) {
    validSegments = {
      ...allSegments
    };
    setValidSegments(validSegments);
  }
  if (value1 == null && Object.keys(validSegments).length === Object.keys(allSegments).length) {
    validSegments = {};
    setValidSegments(validSegments);
    setPlaceholderDate($35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue, granularity, calendar, defaultTimeZone));
  }
  let displayValue = calendarValue && Object.keys(validSegments).length >= Object.keys(allSegments).length ? calendarValue : placeholderDate;
  let setValue = (newValue) => {
    if (props.isDisabled || props.isReadOnly)
      return;
    if (Object.keys(validSegments).length >= Object.keys(allSegments).length) {
      newValue = toCalendar(newValue, (v1 === null || v1 === void 0 ? void 0 : v1.calendar) || new GregorianCalendar());
      setDate(newValue);
    } else
      setPlaceholderDate(newValue);
  };
  let dateValue = useMemo(
    () => displayValue.toDate(timeZone),
    [
      displayValue,
      timeZone
    ]
  );
  let segments = useMemo(
    () => dateFormatter.formatToParts(dateValue).map((segment) => {
      let isEditable = $3c0fc76039f1c516$var$EDITABLE_SEGMENTS[segment.type];
      if (segment.type === "era" && calendar.getEras().length === 1)
        isEditable = false;
      let isPlaceholder = $3c0fc76039f1c516$var$EDITABLE_SEGMENTS[segment.type] && !validSegments[segment.type];
      let placeholder = $3c0fc76039f1c516$var$EDITABLE_SEGMENTS[segment.type] ? $3e3ed55ab2966714$export$d3f5c5e0a5023fa0(segment.type, segment.value, locale) : null;
      return {
        type: $3c0fc76039f1c516$var$TYPE_MAPPING[segment.type] || segment.type,
        text: isPlaceholder ? placeholder : segment.value,
        ...$3c0fc76039f1c516$var$getSegmentLimits(displayValue, segment.type, resolvedOptions),
        isPlaceholder,
        placeholder,
        isEditable
      };
    }),
    [
      dateValue,
      validSegments,
      dateFormatter,
      resolvedOptions,
      displayValue,
      calendar,
      locale
    ]
  );
  if (allSegments.era && validSegments.year && !validSegments.era) {
    validSegments.era = true;
    setValidSegments({
      ...validSegments
    });
  } else if (!allSegments.era && validSegments.era) {
    delete validSegments.era;
    setValidSegments({
      ...validSegments
    });
  }
  let markValid = (part) => {
    validSegments[part] = true;
    if (part === "year" && allSegments.era)
      validSegments.era = true;
    setValidSegments({
      ...validSegments
    });
  };
  let adjustSegment = (type, amount) => {
    if (!validSegments[type]) {
      markValid(type);
      if (Object.keys(validSegments).length >= Object.keys(allSegments).length)
        setValue(displayValue);
    } else
      setValue($3c0fc76039f1c516$var$addSegment(displayValue, type, amount, resolvedOptions));
  };
  let validationState = props.validationState || ($35a22f14a1f04b11$export$eac50920cf2fd59a(calendarValue, props.minValue, props.maxValue) ? "invalid" : null);
  var _maxGranularity1;
  return {
    value: calendarValue,
    dateValue,
    calendar,
    setValue,
    segments,
    dateFormatter,
    validationState,
    granularity,
    maxGranularity: (_maxGranularity1 = props.maxGranularity) !== null && _maxGranularity1 !== void 0 ? _maxGranularity1 : "year",
    isDisabled,
    isReadOnly,
    isRequired,
    increment(part) {
      adjustSegment(part, 1);
    },
    decrement(part) {
      adjustSegment(part, -1);
    },
    incrementPage(part) {
      adjustSegment(part, $3c0fc76039f1c516$var$PAGE_STEP[part] || 1);
    },
    decrementPage(part) {
      adjustSegment(part, -($3c0fc76039f1c516$var$PAGE_STEP[part] || 1));
    },
    setSegment(part, v) {
      markValid(part);
      setValue($3c0fc76039f1c516$var$setSegment(displayValue, part, v, resolvedOptions));
    },
    confirmPlaceholder() {
      if (props.isDisabled || props.isReadOnly)
        return;
      let validKeys = Object.keys(validSegments);
      let allKeys = Object.keys(allSegments);
      if (validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) {
        validSegments = {
          ...allSegments
        };
        setValidSegments(validSegments);
        setValue(displayValue.copy());
      }
    },
    clearSegment(part) {
      delete validSegments[part];
      setValidSegments({
        ...validSegments
      });
      let placeholder = $35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue, granularity, calendar, defaultTimeZone);
      let value = displayValue;
      if (part === "dayPeriod" && "hour" in displayValue && "hour" in placeholder) {
        let isPM = displayValue.hour >= 12;
        let shouldBePM = placeholder.hour >= 12;
        if (isPM && !shouldBePM)
          value = displayValue.set({
            hour: displayValue.hour - 12
          });
        else if (!isPM && shouldBePM)
          value = displayValue.set({
            hour: displayValue.hour + 12
          });
      } else if (part in displayValue)
        value = displayValue.set({
          [part]: placeholder[part]
        });
      setDate(null);
      setValue(value);
    },
    formatValue(fieldOptions) {
      if (!calendarValue)
        return "";
      let formatOptions = $35a22f14a1f04b11$export$7e319ea407e63bc0(fieldOptions, formatOpts);
      let formatter = new DateFormatter(locale, formatOptions);
      return formatter.format(dateValue);
    }
  };
}
function $3c0fc76039f1c516$var$getSegmentLimits(date, type, options) {
  switch (type) {
    case "era": {
      let eras = date.calendar.getEras();
      return {
        value: eras.indexOf(date.era),
        minValue: 0,
        maxValue: eras.length - 1
      };
    }
    case "year":
      return {
        value: date.year,
        minValue: 1,
        maxValue: date.calendar.getYearsInEra(date)
      };
    case "month":
      return {
        value: date.month,
        minValue: getMinimumMonthInYear(date),
        maxValue: date.calendar.getMonthsInYear(date)
      };
    case "day":
      return {
        value: date.day,
        minValue: getMinimumDayInMonth(date),
        maxValue: date.calendar.getDaysInMonth(date)
      };
  }
  if ("hour" in date)
    switch (type) {
      case "dayPeriod":
        return {
          value: date.hour >= 12 ? 12 : 0,
          minValue: 0,
          maxValue: 12
        };
      case "hour":
        if (options.hour12) {
          let isPM = date.hour >= 12;
          return {
            value: date.hour,
            minValue: isPM ? 12 : 0,
            maxValue: isPM ? 23 : 11
          };
        }
        return {
          value: date.hour,
          minValue: 0,
          maxValue: 23
        };
      case "minute":
        return {
          value: date.minute,
          minValue: 0,
          maxValue: 59
        };
      case "second":
        return {
          value: date.second,
          minValue: 0,
          maxValue: 59
        };
    }
  return {};
}
function $3c0fc76039f1c516$var$addSegment(value, part, amount, options) {
  switch (part) {
    case "era":
    case "year":
    case "month":
    case "day":
      return value.cycle(part, amount, {
        round: part === "year"
      });
  }
  if ("hour" in value)
    switch (part) {
      case "dayPeriod": {
        let hours = value.hour;
        let isPM = hours >= 12;
        return value.set({
          hour: isPM ? hours - 12 : hours + 12
        });
      }
      case "hour":
      case "minute":
      case "second":
        return value.cycle(part, amount, {
          round: part !== "hour",
          hourCycle: options.hour12 ? 12 : 24
        });
    }
}
function $3c0fc76039f1c516$var$setSegment(value, part, segmentValue, options) {
  switch (part) {
    case "day":
    case "month":
    case "year":
    case "era":
      return value.set({
        [part]: segmentValue
      });
  }
  if ("hour" in value)
    switch (part) {
      case "dayPeriod": {
        let hours = value.hour;
        let wasPM = hours >= 12;
        let isPM = segmentValue >= 12;
        if (isPM === wasPM)
          return value;
        return value.set({
          hour: wasPM ? hours - 12 : hours + 12
        });
      }
      case "hour":
        if (options.hour12) {
          let hours = value.hour;
          let wasPM = hours >= 12;
          if (!wasPM && segmentValue === 12)
            segmentValue = 0;
          if (wasPM && segmentValue < 12)
            segmentValue += 12;
        }
      case "minute":
      case "second":
        return value.set({
          [part]: segmentValue
        });
    }
}
function $93c38a5e28be6249$export$e50a61c1de9f574(props) {
  var ref, ref1;
  let overlayState = $fc909762b330b746$export$61c6a8c84e605fb6(props);
  let [controlledValue, setControlledValue] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, props.defaultValue || null, props.onChange);
  let [placeholderValue, setPlaceholderValue] = useState(
    () => controlledValue || {
      start: null,
      end: null
    }
  );
  if (controlledValue == null && placeholderValue.start && placeholderValue.end) {
    placeholderValue = {
      start: null,
      end: null
    };
    setPlaceholderValue(placeholderValue);
  }
  let value1 = controlledValue || placeholderValue;
  let setValue = (value) => {
    setPlaceholderValue(value);
    if ((value === null || value === void 0 ? void 0 : value.start) && value.end)
      setControlledValue(value);
    else
      setControlledValue(null);
  };
  let v = (value1 === null || value1 === void 0 ? void 0 : value1.start) || (value1 === null || value1 === void 0 ? void 0 : value1.end) || props.placeholderValue;
  let [granularity] = $35a22f14a1f04b11$export$2440da353cedad43(v, props.granularity);
  let hasTime = granularity === "hour" || granularity === "minute" || granularity === "second" || granularity === "millisecond";
  var _shouldCloseOnSelect;
  let shouldCloseOnSelect = (_shouldCloseOnSelect = props.shouldCloseOnSelect) !== null && _shouldCloseOnSelect !== void 0 ? _shouldCloseOnSelect : true;
  let [dateRange1, setSelectedDateRange] = useState(null);
  let [timeRange1, setSelectedTimeRange] = useState(null);
  if (value1 && value1.start && value1.end) {
    dateRange1 = value1;
    if ("hour" in value1.start)
      timeRange1 = value1;
  }
  let commitValue = (dateRange, timeRange) => {
    setValue({
      start: "timeZone" in timeRange.start ? timeRange.start.set(toCalendarDate(dateRange.start)) : toCalendarDateTime(dateRange.start, timeRange.start),
      end: "timeZone" in timeRange.end ? timeRange.end.set(toCalendarDate(dateRange.end)) : toCalendarDateTime(dateRange.end, timeRange.end)
    });
  };
  let setDateRange = (range) => {
    let shouldClose = typeof shouldCloseOnSelect === "function" ? shouldCloseOnSelect() : shouldCloseOnSelect;
    if (hasTime) {
      if (shouldClose || range.start && range.end && (timeRange1 === null || timeRange1 === void 0 ? void 0 : timeRange1.start) && (timeRange1 === null || timeRange1 === void 0 ? void 0 : timeRange1.end))
        commitValue(range, {
          start: (timeRange1 === null || timeRange1 === void 0 ? void 0 : timeRange1.start) || $35a22f14a1f04b11$export$c5221a78ef73c5e9(props.placeholderValue),
          end: (timeRange1 === null || timeRange1 === void 0 ? void 0 : timeRange1.end) || $35a22f14a1f04b11$export$c5221a78ef73c5e9(props.placeholderValue)
        });
      else
        setSelectedDateRange(range);
    } else if (range.start && range.end)
      setValue(range);
    else
      setSelectedDateRange(range);
    if (shouldClose)
      overlayState.setOpen(false);
  };
  let setTimeRange = (range) => {
    if ((dateRange1 === null || dateRange1 === void 0 ? void 0 : dateRange1.start) && (dateRange1 === null || dateRange1 === void 0 ? void 0 : dateRange1.end) && range.start && range.end)
      commitValue(dateRange1, range);
    else
      setSelectedTimeRange(range);
  };
  let validationState = props.validationState || (value1 != null && ($35a22f14a1f04b11$export$eac50920cf2fd59a(value1.start, props.minValue, props.maxValue) || $35a22f14a1f04b11$export$eac50920cf2fd59a(value1.end, props.minValue, props.maxValue) || value1.end != null && value1.start != null && value1.end.compare(value1.start) < 0 || (value1 === null || value1 === void 0 ? void 0 : value1.start) && ((ref = props.isDateUnavailable) === null || ref === void 0 ? void 0 : ref.call(props, value1.start)) || (value1 === null || value1 === void 0 ? void 0 : value1.end) && ((ref1 = props.isDateUnavailable) === null || ref1 === void 0 ? void 0 : ref1.call(props, value1.end))) ? "invalid" : null);
  return {
    value: value1,
    setValue,
    dateRange: dateRange1,
    timeRange: timeRange1,
    granularity,
    hasTime,
    setDate(part, date) {
      setDateRange({
        ...dateRange1,
        [part]: date
      });
    },
    setTime(part, time) {
      setTimeRange({
        ...timeRange1,
        [part]: time
      });
    },
    setDateTime(part, dateTime) {
      setValue({
        ...value1,
        [part]: dateTime
      });
    },
    setDateRange,
    setTimeRange,
    isOpen: overlayState.isOpen,
    setOpen(isOpen) {
      if (!isOpen && !((value1 === null || value1 === void 0 ? void 0 : value1.start) && (value1 === null || value1 === void 0 ? void 0 : value1.end)) && (dateRange1 === null || dateRange1 === void 0 ? void 0 : dateRange1.start) && (dateRange1 === null || dateRange1 === void 0 ? void 0 : dateRange1.end) && hasTime)
        commitValue(dateRange1, {
          start: (timeRange1 === null || timeRange1 === void 0 ? void 0 : timeRange1.start) || $35a22f14a1f04b11$export$c5221a78ef73c5e9(props.placeholderValue),
          end: (timeRange1 === null || timeRange1 === void 0 ? void 0 : timeRange1.end) || $35a22f14a1f04b11$export$c5221a78ef73c5e9(props.placeholderValue)
        });
      overlayState.setOpen(isOpen);
    },
    validationState,
    formatValue(locale, fieldOptions) {
      if (!value1 || !value1.start || !value1.end)
        return null;
      let startTimeZone = "timeZone" in value1.start ? value1.start.timeZone : void 0;
      let startGranularity = props.granularity || (value1.start && "minute" in value1.start ? "minute" : "day");
      let endTimeZone = "timeZone" in value1.end ? value1.end.timeZone : void 0;
      let endGranularity = props.granularity || (value1.end && "minute" in value1.end ? "minute" : "day");
      let startOptions = $35a22f14a1f04b11$export$7e319ea407e63bc0(fieldOptions, {
        granularity: startGranularity,
        timeZone: startTimeZone,
        hideTimeZone: props.hideTimeZone,
        hourCycle: props.hourCycle,
        showEra: value1.start.calendar.identifier === "gregory" && value1.start.era === "BC" || value1.end.calendar.identifier === "gregory" && value1.end.era === "BC"
      });
      let startDate = value1.start.toDate(startTimeZone || "UTC");
      let endDate = value1.end.toDate(endTimeZone || "UTC");
      let startFormatter = new DateFormatter(locale, startOptions);
      let endFormatter;
      if (startTimeZone === endTimeZone && startGranularity === endGranularity && value1.start.compare(value1.end) !== 0) {
        try {
          let parts = startFormatter.formatRangeToParts(startDate, endDate);
          let separatorIndex = -1;
          for (let i = 0; i < parts.length; i++) {
            let part = parts[i];
            if (part.source === "shared" && part.type === "literal")
              separatorIndex = i;
            else if (part.source === "endRange")
              break;
          }
          let start = "";
          let end = "";
          for (let i1 = 0; i1 < parts.length; i1++) {
            if (i1 < separatorIndex)
              start += parts[i1].value;
            else if (i1 > separatorIndex)
              end += parts[i1].value;
          }
          return {
            start,
            end
          };
        } catch (e) {
        }
        endFormatter = startFormatter;
      } else {
        let endOptions = $35a22f14a1f04b11$export$7e319ea407e63bc0(fieldOptions, {
          granularity: endGranularity,
          timeZone: endTimeZone,
          hideTimeZone: props.hideTimeZone,
          hourCycle: props.hourCycle
        });
        endFormatter = new DateFormatter(locale, endOptions);
      }
      return {
        start: startFormatter.format(startDate),
        end: endFormatter.format(endDate)
      };
    }
  };
}
function createCalendar(identifier) {
  switch (identifier) {
    case "gregory":
      return new GregorianCalendar();
    default:
      throw new Error(`Unsupported calendar ${identifier}`);
  }
}
function DateField(props) {
  var _a;
  const locale = useCurrentLocale();
  const styles = useMultiStyleConfig("Datepicker", {});
  const state = $3c0fc76039f1c516$export$60e84778edff6d26({
    ...props,
    locale,
    createCalendar
  });
  const ref = useRef(null);
  const { fieldProps, labelProps } = $16f0b7bb276bc17e$export$5591b0b878c1a989(props, state, ref);
  return /* @__PURE__ */ React.createElement(Box, null, props.label && /* @__PURE__ */ React.createElement(FormLabel, {
    ...props.labelProps,
    ...labelProps,
    sx: styles.inputLabel
  }, props.label), /* @__PURE__ */ React.createElement(Flex, {
    ...fieldProps,
    ref
  }, state.segments.map((segment, i) => /* @__PURE__ */ React.createElement(DateSegment, {
    key: i,
    segment,
    state
  }))), /* @__PURE__ */ React.createElement("input", {
    type: "hidden",
    value: (_a = state.value) == null ? void 0 : _a.toString(),
    name: props.name
  }));
}
var StyledField = forwardRef(
  ({ children, variant, ...otherProps }, ref) => {
    const styles = useMultiStyleConfig("Datepicker", { variant });
    return /* @__PURE__ */ React.createElement(Box, {
      sx: styles.wrapper,
      ...otherProps,
      ref
    }, children);
  }
);
function DateSegment({ segment, state }) {
  const ref = useRef(null);
  const { segmentProps } = $32489daedd52963e$export$1315d136e6f7581(segment, state, ref);
  return /* @__PURE__ */ React.createElement(Box, {
    ...segmentProps,
    ref,
    style: {
      ...segmentProps.style,
      fontVariantNumeric: "tabular-nums",
      boxSizing: "content-box"
    },
    boxSizing: "content-box",
    px: "1px",
    textAlign: "end",
    outline: "none",
    borderRadius: "xs",
    color: segment.isPlaceholder ? "alias.osloGrey" : segment.isEditable ? "alias.darkGrey" : "alias.osloGrey",
    _focus: {
      backgroundColor: "alias.darkTeal",
      color: "white"
    }
  }, segment.text);
}

export { $6057a3d2a53a12fd$export$42df105a73306d51, $887cac91b7cc8801$export$12fd5f0e9f4bb192, $93c38a5e28be6249$export$e50a61c1de9f574, $ab5bf3f618090389$export$87194bb378cc3ac2, DateField, StyledField };
